(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["line-item"] && !Shopify.designMode) return;
  try {
    /*
    Solange eine nicht mehr verfuegbare Verkaufsposition im Warenkorb liegt,
    wird der Kassen-Button gesperrt und darueber erklaert, warum. Gezaehlt wird
    nur, was Liquid als [data-sf-unavailable] markiert hat - die interne
    Gravurgebuehr ist dort ausgenommen. Entfernt wird ueber die bestehende
    Warenkorb-Logik; danach zeichnet das Theme neu und diese Pruefung laeuft
    erneut. Warenkorb-, Rabatt- und Gravurlogik bleiben unberuehrt.
  */
  (() => {
    // {% javascript %} rendert kein Liquid: Text kommt aus window.SideFillStrings (sf-i18n).
    const HINWEIS = (window.SideFillStrings && window.SideFillStrings.cartRemoveUnavailable) || 'Bitte entferne nicht mehr verfügbare Artikel, bevor du zur Kasse gehst.';

    const pruefen = () => {
      const offen = document.querySelectorAll('[data-sf-unavailable]').length;

      document.querySelectorAll('[name="checkout"]').forEach((knopf) => {
        const behaelter = knopf.closest('form') || knopf.parentElement;
        if (!behaelter) return;

        let hinweis = behaelter.querySelector('[data-sf-cart-block]');
        if (offen > 0) {
          knopf.disabled = true;
          knopf.setAttribute('aria-disabled', 'true');
          knopf.classList.add('sf-cart-blocked');
          if (!hinweis) {
            hinweis = document.createElement('p');
            hinweis.className = 'sf-cart-block';
            hinweis.setAttribute('data-sf-cart-block', '');
            hinweis.setAttribute('role', 'status');
            hinweis.textContent = HINWEIS;
            (knopf.closest('.button-group') || knopf.parentElement).insertBefore(hinweis, knopf.closest('.button-group') ? knopf.closest('.button-group').firstChild : knopf);
          }
        } else {
          knopf.disabled = false;
          knopf.removeAttribute('aria-disabled');
          knopf.classList.remove('sf-cart-blocked');
          if (hinweis) hinweis.remove();
        }
      });
    };

    const start = () => {
      pruefen();
      // Das Theme tauscht den Warenkorbinhalt aus; danach erneut pruefen.
      document.documentElement.addEventListener('cart:change', pruefen);
      document.documentElement.addEventListener('cart:refresh', pruefen);
      const beobachter = new MutationObserver(() => pruefen());
      document.querySelectorAll('cart-drawer, cart-form, .cart, main').forEach((ziel) => {
        beobachter.observe(ziel, { childList: true, subtree: true });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-color-mix"] && !Shopify.designMode) return;
  try {
    /**
   * Shared Flow A state, extended field by field so this file and sf-engraving-choice
   * can be loaded in either order without one overwriting the other's half.
   */
  window.SFEngraving = window.SFEngraving || {};
  window.SFEngraving.modes = window.SFEngraving.modes || new Map();
  window.SFEngraving.colors = window.SFEngraving.colors || new Map();
  window.SFEngraving.handoverKey = window.SFEngraving.handoverKey || 'sf:flow-a:handover';

  window.SFEngraving.readMode = window.SFEngraving.readMode || function (formId) {
    return window.SFEngraving.modes.get(formId) || 'none';
  };

  window.SFEngraving.writeMode = window.SFEngraving.writeMode || function (formId, mode) {
    window.SFEngraving.modes.set(formId, mode);
    document.dispatchEvent(new CustomEvent('sf:engraving-mode', { detail: { formId, mode } }));
  };

  /** @returns {{ mode: string, variantIds: string[] }} */
  window.SFEngraving.readColors = window.SFEngraving.readColors || function (formId) {
    return window.SFEngraving.colors.get(formId) || { mode: 'off', variantIds: [] };
  };

  window.SFEngraving.writeColors = window.SFEngraving.writeColors || function (formId, value) {
    window.SFEngraving.colors.set(formId, value);
    document.dispatchEvent(new CustomEvent('sf:color-mix', { detail: { formId, ...value } }));
  };

  /**
   * Tells whether an element belongs to a given product form, whether it sits inside the
   * form or is only associated with it through a `form` attribute. Prestige puts the
   * quantity field outside the form, so DOM containment alone is not enough.
   *
   * @param {Element | null} element
   * @param {string} formId
   */
  window.SFEngraving.belongsToForm = window.SFEngraving.belongsToForm || function (element, formId) {
    if (!element || !formId) return false;
    if (element.getAttribute && element.getAttribute('form') === formId) return true;
    const owner = element.closest ? element.closest('form') : null;
    return Boolean(owner && owner.id === formId);
  };

  class SfColorMix extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.maxSlots = Number(this.dataset.maxSlots || 5);
      this.optionPosition = this.dataset.optionPosition || '1';
      this.errorNode = this.querySelector('[data-sf-mix-error]');

      /** Single source of truth: one variant id per bottle, in bottle order. */
      const restored = window.SFEngraving.readColors(this.formId);
      this.variantIds = Array.isArray(restored.variantIds) ? restored.variantIds.slice() : [];

      /*
       * Zwei getrennte Zustaende:
       *   variantIds  was gekauft wird — nur verfuegbare Varianten, treibt Picker und Warenkorb
       *   preview     was gerade angesehen wird — { slot, variantId }, darf ausverkauft sein,
       *               bewegt nur die Galerie und veraendert variantIds nie
       * Die Vorschau liegt wie die Farben im gemeinsamen Register, damit sie ein
       * Neuzeichnen des Themes uebersteht.
       */
      window.SFEngraving.previews = window.SFEngraving.previews || new Map();
      this.preview = window.SFEngraving.previews.get(this.formId) || null;

      /** Bilder je Variante fuer die Vorschau-Galerie. */
      this.media = (() => {
        const node = this.querySelector('[data-sf-mix-media]');
        try { return node ? JSON.parse(node.textContent) : {}; } catch (error) { return {}; }
      })();

      /** Alle Produktmedien nach ID, um Rios Variantenzuordnung aufzuloesen. */
      this.mediaIndex = (() => {
        const node = this.querySelector('[data-sf-mix-media-index]');
        try { return node ? JSON.parse(node.textContent) : {}; } catch (error) { return {}; }
      })();

      /** Verfuegbarkeit je Variante, einmal aus den Farbfeldern der ersten Zeile gelesen. */
      this.availability = new Map();
      this.querySelectorAll('[data-sf-mix-slot="1"] .sf-color-mix__swatch').forEach((swatch) => {
        this.availability.set(swatch.dataset.sfMixVariant, swatch.dataset.sfMixAvailable !== 'false');
      });

      // One controller for every listener, so a re-render can never leave a stale
      // listener behind or register a second one.
      this.controller = new AbortController();
      // options darf ein Boolean sein — { ...true } waere {} und wuerde capture verschlucken.
      const on = (target, type, handler, options) => {
        const opts = typeof options === 'boolean' ? { capture: options } : { ...(options || {}) };
        target.addEventListener(type, handler, { ...opts, signal: this.controller.signal });
      };

      on(this, 'click', (event) => this.onClick(event));

      // Die Vorschau-Ebene liegt in der Galerie, nicht in diesem Element.
      on(document, 'click', (event) => {
        const overlay = event.target.closest?.('.sf-gallery-preview');
        if (!overlay || overlay.dataset.formId !== this.formId) return;
        if (event.target.closest('[data-sf-gallery-preview-close]')) return this.endPreview();
        const step = event.target.closest('[data-sf-preview-step]');
        if (step) return this.stepPreview(Number(step.dataset.sfPreviewStep));
        const thumbScroll = event.target.closest('[data-sf-preview-thumbscroll]');
        if (thumbScroll) return this.scrollThumbs(overlay, Number(thumbScroll.dataset.sfPreviewThumbscroll));
        const thumb = event.target.closest('[data-sf-preview-thumb], [data-sf-preview-dot]');
        if (thumb) return this.showPreviewImage(Number(thumb.dataset.sfPreviewThumb ?? thumb.dataset.sfPreviewDot));
      });

      // Pfeile der Miniaturleiste haengen an der verfuegbaren Breite.
      on(window, 'resize', () => {
        const overlay = this.previewOverlay();
        if (overlay && !overlay.hidden) this.updateThumbNav(overlay);
      }, { passive: true });

      // Mobile-Sticky: nur ein- und ausblenden, nie selbst scrollen.
      this.sticky = this.querySelector('[data-sf-mix-sticky]');
      this.stickyFrame = 0;
      const planSticky = () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {
          this.stickyFrame = 0;
          this.updateStickyVisibility();
        });
      };
      on(window, 'scroll', planSticky, { passive: true });
      on(window, 'resize', planSticky, { passive: true });

      // Pfeiltasten, wenn der Bildstreifen den Fokus hat.
      on(document, 'keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const track = event.target.closest?.('[data-sf-preview-track]');
        if (!track || track.closest('.sf-gallery-preview')?.dataset.formId !== this.formId) return;
        event.preventDefault();
        this.stepPreview(event.key === 'ArrowRight' ? 1 : -1);
      });

      /*
       * Listening on `document` rather than on the form is deliberate. The quantity
       * field lives outside the form and is only associated with it, so its events
       * never travel through the form element. Binding to the form meant quantity
       * changes were silently missed.
       */
      const onFieldChange = (event) => {
        const target = event.target;
        if (!target || target.name !== 'quantity') return;
        if (!window.SFEngraving.belongsToForm(target, this.formId)) return;
        // Erst begrenzen, dann zeichnen — sonst zeichnet die erste Runde einen
        // Zustand, den das Feld gleich darauf wieder verlaesst.
        if (this.clampQuantityField()) {
          target.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        this.render();
        this.publish();
      };
      on(document, 'input', onFieldChange);
      on(document, 'change', onFieldChange);

      /*
       * Der Mengen-Stepper des Themes ruft input.stepUp() und feuert dabei kein
       * Event — ohne diesen Klick-Listener bliebe eine Mengenaenderung ueber + und −
       * unbemerkt, bis zufaellig ein Variantenwechsel folgt. Nach dem Klick auf den
       * naechsten Frame warten, damit stepUp() schon gelaufen ist.
       */
      on(document, 'click', (event) => {
        const stepper = event.target.closest?.('quantity-selector');
        if (!stepper) return;
        const field = stepper.querySelector('[name="quantity"]');
        if (!window.SFEngraving.belongsToForm(field, this.formId)) return;
        // Zweimal nachsehen: der naechste Frame reicht fuer stepUp(), aber wenn
        // eine App den Wert erst verzoegert setzt, waere die Auswahl sonst dauerhaft
        // einen Klick im Rueckstand — genau das Bild, das den Umbau ausgeloest hat.
        const nachziehen = () => {
          this.clampQuantityField();
          this.render();
          this.publish();
        };
        requestAnimationFrame(nachziehen);
        setTimeout(nachziehen, 120);
      });

      on(document, 'variant:change', (event) => {
        if (event.detail?.formId && event.detail.formId !== this.formId) return;
        this.render();
      });

      on(document, 'sf:engraving-mode', (event) => {
        if (event.detail.formId !== this.formId) return;
        this.render();
        this.publish();
      });

      // Capture on document, so the interception works even after the theme has
      // replaced the form element itself.
      on(document, 'submit', (event) => this.onSubmit(event), true);

      this.clampQuantityField();
      this.buildCounts();
      this.guardSoldOutStart();
      this.render();
      this.publish();
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
      window.clearTimeout(this.flashTimer);
    }

    /** Resolved on demand — the theme replaces the form on a full re-render. */
    get form() {
      return document.forms[this.formId] || null;
    }

    quantity() {
      const raw = Number(this.form?.elements?.quantity?.value || 1);
      return Math.max(1, Math.round(raw) || 1);
    }

    /**
     * Frueher war die Menge auf die Zahl der Flaschenzeilen begrenzt, weil es darueber
     * keine Farbwahl gab. Seit der Stueckzahl-Ansicht gibt es keine Obergrenze mehr —
     * uebrig bleibt nur, ein von einer frueheren Fassung gesetztes Maximum zu entfernen.
     *
     * @returns {boolean} immer false: der Wert wird nie gekuerzt.
     */
    clampQuantityField() {
      const field = this.form?.elements?.quantity;
      if (field && field.getAttribute('max') === String(this.maxSlots)) field.removeAttribute('max');
      return false;
    }

    /** The variant the native picker currently points at. */
    pickerVariantId() {
      return String(this.form?.elements?.id?.value || '');
    }

    /** The only colour control on the page, so it is active at every quantity. */
    isActive() {
      return true;
    }

    /** Mehr Flaschen als Zeilen: Stueckzahl je Farbe statt einer Zeile je Flasche. */
    countsMode(quantity) {
      return quantity > this.maxSlots;
    }

    /**
     * Baut die Zeilen der Stueckzahl-Ansicht einmal aus den Farbpunkten der ersten
     * Flasche — Farben, Namen und Verfuegbarkeit stehen dort schon, eine zweite
     * Liste im Liquid koennte davon nur abweichen.
     */
    buildCounts() {
      const host = this.querySelector('[data-sf-mix-counts]');
      if (!host || host.childElementCount) return;
      const soldOut = this.dataset.soldoutShort || '';
      this.orderedSwatches().forEach((swatch) => {
        const colour = swatch.dataset.sfMixColor || '';
        const available = swatch.dataset.sfMixAvailable !== 'false';
        const row = document.createElement('div');
        row.className = 'sf-color-mix__count-row';
        row.dataset.sfMixCount = swatch.dataset.sfMixVariant;

        const dot = document.createElement('span');
        dot.className = 'sf-color-mix__count-dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.style.setProperty(
          '--sf-swatch-color',
          swatch.querySelector('.sf-color-mix__swatch-color')?.style.getPropertyValue('--sf-swatch-color') || '#ddd'
        );

        const name = document.createElement('span');
        name.className = 'sf-color-mix__count-name';
        name.textContent = colour;
        if (!available && soldOut) {
          const note = document.createElement('small');
          note.textContent = soldOut;
          name.append(note);
        }

        const stepper = document.createElement('span');
        stepper.className = 'sf-color-mix__count-stepper';
        const button = (step, sign, label) => {
          const node = document.createElement('button');
          node.type = 'button';
          node.dataset.sfMixCountStep = String(step);
          node.textContent = sign;
          node.setAttribute('aria-label', (label || '').replace('[colour]', colour));
          return node;
        };
        const value = document.createElement('output');
        value.className = 'sf-color-mix__count-value';
        value.dataset.sfMixCountValue = '';
        value.textContent = '0';
        stepper.append(button(-1, '−', this.dataset.countLess), value, button(1, '+', this.dataset.countMore));

        row.append(dot, name, stepper);
        host.append(row);
      });
    }

    /** Zeichnet die Stueckzahlen aus variantIds; aendert selbst nichts am Zustand. */
    renderCounts(visible) {
      const host = this.querySelector('[data-sf-mix-counts]');
      const hint = this.querySelector('[data-sf-mix-counts-hint]');
      if (hint) hint.hidden = !visible;
      if (!host) return;
      host.hidden = !visible;
      if (!visible) return;
      host.querySelectorAll('[data-sf-mix-count]').forEach((row) => {
        const variantId = String(row.dataset.sfMixCount);
        const count = this.variantIds.filter((id) => String(id) === variantId).length;
        const available = this.isAvailable(variantId);
        row.dataset.sfMixCountEmpty = String(count === 0);
        row.querySelector('[data-sf-mix-count-value]').textContent = String(count);
        row.querySelector('[data-sf-mix-count-step="-1"]').disabled = count === 0;
        row.querySelector('[data-sf-mix-count-step="1"]').disabled = !available;
      });
    }

    /**
     * Eine Flasche dieser Farbe mehr oder weniger. Die Menge folgt den Farben, nicht
     * umgekehrt: variantIds wird geaendert, das Mengenfeld zieht nach — damit sehen
     * Mengenkarten, Rabattzeile und Warenkorb denselben Stand wie bisher.
     */
    stepCount(variantId, delta) {
      if (delta > 0) {
        if (!this.isAvailable(variantId)) return;
        this.variantIds.push(variantId);
      } else {
        const at = this.variantIds.lastIndexOf(variantId);
        if (at === -1 || this.variantIds.length <= 1) return;
        this.variantIds.splice(at, 1);
      }
      this.hideError();

      const field = this.form?.elements?.quantity;
      if (field) {
        field.value = String(this.variantIds.length);
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.syncLead();
      this.render();
      this.publish();
    }

    /**
     * Die erste Flasche fuehrt Galerie, Preis und URL. Faellt ihre Farbe in der
     * Stueckzahl-Ansicht auf null, rueckt eine andere Farbe an die erste Stelle —
     * dann muss der native Picker mitziehen.
     */
    syncLead() {
      const lead = String(this.variantIds[0] || '');
      if (!lead || lead === this.pickerVariantId()) return;
      const swatch = Array.from(this.querySelectorAll('[data-sf-mix-slot="1"] .sf-color-mix__swatch'))
        .find((candidate) => candidate.dataset.sfMixVariant === lead);
      if (swatch) this.syncPicker(swatch.dataset.sfMixOptionValue);
    }

    onClick(event) {
      const step = event.target.closest('[data-sf-mix-count-step]');
      if (step) {
        const row = step.closest('[data-sf-mix-count]');
        if (row && !step.disabled) this.stepCount(String(row.dataset.sfMixCount), Number(step.dataset.sfMixCountStep));
        return;
      }
      const swatch = event.target.closest('.sf-color-mix__swatch');
      if (!swatch || swatch.disabled) return;
      const row = swatch.closest('[data-sf-mix-slot]');
      if (!row) return;
      const slot = Number(row.dataset.sfMixSlot);
      if (this.isAvailable(swatch.dataset.sfMixVariant)) this.selectColor(slot, swatch);
      else this.startPreview(slot, swatch);
      // Jeder Klick zeigt die Farbe gross — aus welcher Zeile er auch kommt.
    }

    isAvailable(variantId) {
      return this.availability.get(String(variantId)) !== false;
    }

    /** Farbpunkte der ersten Flasche so, wie sie angezeigt werden: Startfarbe vorne, Ausverkauftes hinten. */
    orderedSwatches() {
      const rank = (swatch) => {
        if (swatch.hasAttribute('data-sf-mix-start')) return -1;
        return swatch.dataset.sfMixAvailable === 'false' ? 1 : 0;
      };
      return Array.from(this.querySelectorAll('[data-sf-mix-slot="1"] .sf-color-mix__swatch'))
        .map((swatch, index) => ({ swatch, index }))
        .sort((a, b) => rank(a.swatch) - rank(b.swatch) || a.index - b.index)
        .map(({ swatch }) => swatch);
    }

    firstAvailableSwatch() {
      return this.orderedSwatches().find((swatch) => swatch.dataset.sfMixAvailable !== 'false') || null;
    }

    /**
     * Verfuegbare Farbe waehlen: sie wird fuer genau diese Flasche gespeichert UND
     * gross gezeigt. Die Vorschau merkt sich nur, welche Flasche zuletzt dran war —
     * die Farben der anderen Flaschen bleiben unberuehrt.
     */
    selectColor(slotIndex, swatch) {
      // Nur verfuegbare Varianten landen je im Kaufzustand.
      if (!this.isAvailable(swatch.dataset.sfMixVariant)) return;
      this.variantIds[slotIndex - 1] = swatch.dataset.sfMixVariant;
      this.hideError();

      this.setPreview({ slot: slotIndex, variantId: swatch.dataset.sfMixVariant, index: 0 });

      // Nur Flasche 1 fuehrt den nativen Picker und damit Galerie, Preis und URL.
      // Flasche 2 bis 10 zeigen ihre Farbe ueber die Vorschau-Ebene — sie duerfen die
      // kaufbare Hauptvariante nie ueberschreiben.
      if (slotIndex === 1) this.syncPicker(swatch.dataset.sfMixOptionValue);

      this.render();
      this.publish();
      this.flashRow(slotIndex, swatch);
    }

    /**
     * Kurze Bestaetigung nach einem Farbklick: die Zeile faerbt sich 450 ms hell
     * blau, der geklickte Farbpunkt hebt sich dabei leicht an. Rein visuell —
     * danach ist die Zeile wieder vollstaendig neutral.
     */
    flashRow(slotIndex, swatch) {
      const row = this.querySelector(`[data-sf-mix-slot="${slotIndex}"]`);
      if (!row) return;
      window.clearTimeout(this.flashTimer);
      this.querySelectorAll('.is-just-picked').forEach((other) => other.classList.remove('is-just-picked'));
      // Neu anstossen, auch wenn dieselbe Zeile kurz zuvor schon leuchtete.
      void row.offsetWidth;
      row.classList.add('is-just-picked');
      if (swatch) swatch.classList.add('is-just-picked');
      this.flashTimer = window.setTimeout(() => {
        row.classList.remove('is-just-picked');
        if (swatch) swatch.classList.remove('is-just-picked');
      }, 450);
    }

    /**
     * Ausverkaufte Farbe ansehen: Galerie zeigt sie, die Zeile sagt "nur Vorschau".
     * variantIds, Picker, Preis und Warenkorb bleiben unberuehrt. Derselbe
     * Vorschau-Zustand wie bei verfuegbaren Farben, nur ohne Auswahl.
     */
    startPreview(slotIndex, swatch) {
      this.setPreview({ slot: slotIndex, variantId: swatch.dataset.sfMixVariant, index: 0 });
      this.render();
    }

    setPreview(value) {
      this.preview = value;
      if (value) window.SFEngraving.previews.set(this.formId, value);
      else window.SFEngraving.previews.delete(this.formId);
      document.dispatchEvent(new CustomEvent('sf:color-preview', { detail: { formId: this.formId, preview: value } }));
    }

    /**
     * Die Galerie dieser Seite gehoert der Swatch-App (ProductWiz Rio). Sie zeigt nur
     * die Bilder der gewaehlten Variante und hat keine Schnittstelle, um eine andere
     * Farbe zu zeigen, ohne die Variante zu wechseln — und genau das darf eine
     * ausverkaufte Farbe nie. Deshalb eine eigene Ebene ueber der Galerie: sie zeigt
     * das Foto der angesehenen Farbe, App, Picker und Variante bleiben unberuehrt.
     * Verschwindet die Ebene, steht darunter wieder die Galerie der kaufbaren Variante.
     */
    galleryHost() {
      return Array.from(document.querySelectorAll('product-gallery'))
        .find((candidate) => candidate.getAttribute('form') === this.formId) || null;
    }

    previewOverlay() {
      return Array.from(document.querySelectorAll('.sf-gallery-preview'))
        .find((candidate) => candidate.dataset.formId === this.formId) || null;
    }

    /**
     * Die Ebene braucht es nur, wenn die echte Galerie die angesehene Farbe nicht
     * ohnehin zeigt: Flasche 1 fuehrt den Picker, ihre verfuegbare Farbe steht also
     * schon gross da. Alles andere — Flasche 2 bis 10 und jede ausverkaufte Farbe —
     * bekommt die Ebene.
     */
    previewNeedsOverlay(swatch, slot) {
      return swatch.dataset.sfMixAvailable === 'false' || slot !== 1;
    }

    /**
     * Bilder einer Variante — aus derselben Quelle, aus der Rio die Galerie einer
     * verfuegbaren Variante baut: Rios Variantenzuordnung (nur gelesen), in ihrer
     * Reihenfolge. Die Verfuegbarkeit beeinflusst nur den Kauf, nie die Bilder.
     * Die Dateinamen-Zuordnung greift nur, wenn Rio fuer die Variante nichts hat.
     */
    mediaFor(variantId, fallbackAlt) {
      const rio = window.__productWizRioVariantImages;
      const eintrag = rio && Array.isArray(rio.mapping)
        ? rio.mapping.find((zuordnung) => String(zuordnung.id) === variantId)
        : null;
      const ausRio = eintrag && Array.isArray(eintrag.media)
        ? eintrag.media.map((id) => this.mediaIndex[String(id)]).filter(Boolean)
        : [];
      const bilder = ausRio.length ? ausRio : (this.media[variantId] || []);
      return bilder.map((bild) => ({ ...bild, alt: bild.alt || fallbackAlt || '' }));
    }

    showPreviewOverlay(swatch, slot) {
      const host = this.galleryHost();
      if (!host) return;
      const variantId = String(swatch.dataset.sfMixVariant);
      const varianteBilder = this.mediaFor(variantId, swatch.dataset.sfMixColor);
      const bilder = varianteBilder.length
        ? varianteBilder
        : (swatch.dataset.sfMixImage ? [{ src: swatch.dataset.sfMixImage, thumb: swatch.dataset.sfMixImage, alt: '' }] : []);
      if (!bilder.length) return;
      host.classList.add('sf-gallery-preview-host');

      let overlay = this.previewOverlay();
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'sf-gallery-preview';
        overlay.dataset.formId = this.formId;
        overlay.innerHTML = `
          <div class="sf-gallery-preview__stage">
            <div class="sf-gallery-preview__frame">
              <div class="sf-gallery-preview__track" data-sf-preview-track tabindex="0"></div>
              <button type="button" class="sf-gallery-preview__arrow sf-gallery-preview__arrow--prev" data-sf-preview-step="-1" aria-label="${((window.SideFillStrings || {}).galleryPrevious || 'Vorheriges Bild')}">
                <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><path d="M10 2 4 8l6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
              </button>
              <button type="button" class="sf-gallery-preview__arrow sf-gallery-preview__arrow--next" data-sf-preview-step="1" aria-label="${((window.SideFillStrings || {}).galleryNext || 'Nächstes Bild')}">
                <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><path d="m6 2 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
              </button>
            </div>
            <div class="sf-gallery-preview__thumbbar">
              <button type="button" class="sf-gallery-preview__thumbnav sf-gallery-preview__thumbnav--prev" data-sf-preview-thumbscroll="-1" aria-label="${((window.SideFillStrings || {}).galleryThumbsLeft || 'Miniaturen nach links')}" hidden>
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
              </button>
              <div class="sf-gallery-preview__thumbs" data-sf-preview-thumbs role="group" aria-label="${((window.SideFillStrings || {}).galleryMore || 'Weitere Bilder')}"></div>
              <button type="button" class="sf-gallery-preview__thumbnav sf-gallery-preview__thumbnav--next" data-sf-preview-thumbscroll="1" aria-label="${((window.SideFillStrings || {}).galleryThumbsRight || 'Miniaturen nach rechts')}" hidden>
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
              </button>
            </div>
            <div class="sf-gallery-preview__dots" data-sf-preview-dots role="group" aria-label="${((window.SideFillStrings || {}).galleryMore || 'Weitere Bilder')}"></div>
            <div class="sf-gallery-preview__bar">
              <span class="sf-gallery-preview__label" data-sf-gallery-preview-label></span>
              <button type="button" class="sf-gallery-preview__close" data-sf-gallery-preview-close></button>
            </div>
          </div>`;
        host.appendChild(overlay);
        // Wischen und Scrollen halten die aktive Miniatur nach; das laeuft ohne
        // Neuzeichnen, damit der Zustand beim Wischen nicht springt.
        overlay.querySelector('[data-sf-preview-track]').addEventListener('scroll', () => {
          const index = this.trackIndex(overlay);
          if (this.preview && this.preview.index !== index) this.preview.index = index;
          this.markThumb(overlay, index);
        }, { passive: true, signal: this.controller.signal });
        overlay.querySelector('[data-sf-preview-thumbs]').addEventListener('scroll', () => {
          this.updateThumbNav(overlay);
        }, { passive: true, signal: this.controller.signal });
      }

      const colour = swatch.dataset.sfMixColor || '';
      const soldOut = swatch.dataset.sfMixAvailable === 'false';
      // Ausverkauft hat Vorrang: dort zaehlt die Warnung, nicht die Flaschennummer.
      // Kurz halten: die Zeile rechts erklaert bereits "nur Vorschau" und welche
      // Farbe tatsaechlich gewaehlt ist.
      // Kurz halten: die Pille sitzt am Bild, das Praefix "Vorschau" waere Ballast.
      const label = soldOut
        ? `${colour} · ${this.dataset.soldoutShort || ((window.SideFillStrings || {}).colorMixSoldOut || 'Ausverkauft')}`
        : `${this.bottleLabel(slot)} · ${colour}`;
      overlay.setAttribute('role', 'region');
      overlay.setAttribute('aria-label', soldOut ? ((window.SideFillStrings || {}).colorMixAriaSoldOut || 'Vorschau: [colour], ausverkauft').replace('[colour]', () => colour) : ((window.SideFillStrings || {}).colorMixAriaBottle || 'Vorschau: [bottle], [colour]').replace('[bottle]', () => this.bottleLabel(slot)).replace('[colour]', () => colour));
      overlay.querySelector('[data-sf-gallery-preview-label]').textContent = label;
      const closeButton = overlay.querySelector('[data-sf-gallery-preview-close]');
      closeButton.textContent = '×';
      closeButton.setAttribute('aria-label', this.dataset.previewCloseLabel || ((window.SideFillStrings || {}).colorMixPreviewClose || 'Vorschau schliessen'));
      closeButton.setAttribute('title', this.dataset.previewCloseLabel || ((window.SideFillStrings || {}).colorMixPreviewClose || 'Vorschau schliessen'));
      overlay.dataset.slot = String(slot);

      const track = overlay.querySelector('[data-sf-preview-track]');
      const thumbs = overlay.querySelector('[data-sf-preview-thumbs]');
      if (overlay.dataset.variantId !== variantId) {
        overlay.dataset.variantId = variantId;
        track.innerHTML = bilder
          .map((bild, index) => `<img class="sf-gallery-preview__image" src="${this.escape(bild.src)}" alt="${this.escape(bild.alt || colour)}" data-sf-preview-slide="${index}" loading="${index === 0 ? 'eager' : 'lazy'}">`)
          .join('');
        thumbs.innerHTML = bilder.length > 1
          ? bilder.map((bild, index) => `<button type="button" class="sf-gallery-preview__thumb" data-sf-preview-thumb="${index}" aria-label="${((window.SideFillStrings || {}).galleryImageOf || 'Bild [n] von [total]').replace('[n]', index + 1).replace('[total]', bilder.length)}"><img src="${this.escape(bild.thumb)}" alt="" loading="lazy"></button>`).join('')
          : '';
        // Wie die native Galerie: auf schmalen Fenstern Punkte statt Miniaturen.
        overlay.querySelector('[data-sf-preview-dots]').innerHTML = bilder.length > 1
          ? bilder.map((bild, index) => `<button type="button" class="sf-gallery-preview__dot" data-sf-preview-dot="${index}" aria-label="${((window.SideFillStrings || {}).galleryImageOf || 'Bild [n] von [total]').replace('[n]', index + 1).replace('[total]', bilder.length)}"></button>`).join('')
          : '';
      }

      const index = Math.min(Math.max(Number(this.preview?.index || 0), 0), bilder.length - 1);
      if (this.preview) this.preview.index = index;
      overlay.hidden = false;
      this.scrollTrack(overlay, index, 'auto');
      this.markThumb(overlay, index);
    }

    /** Index des Bildes, das gerade im Rahmen steht. */
    trackIndex(overlay) {
      const track = overlay.querySelector('[data-sf-preview-track]');
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    scrollTrack(overlay, index, behavior) {
      const track = overlay.querySelector('[data-sf-preview-track]');
      if (!track) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: behavior || 'smooth' });
    }

    markThumb(overlay, index) {
      overlay.querySelectorAll('[data-sf-preview-thumb], [data-sf-preview-dot]').forEach((knopf) => {
        const active = Number(knopf.dataset.sfPreviewThumb ?? knopf.dataset.sfPreviewDot) === index;
        knopf.classList.toggle('is-active', active);
        knopf.setAttribute('aria-current', String(active));
      });

      // Wie Rio: ueberlaeuft die Leiste, rueckt die aktive Miniatur in den sichtbaren Bereich.
      const leiste = overlay.querySelector('[data-sf-preview-thumbs]');
      const aktiv = leiste && leiste.querySelector('.sf-gallery-preview__thumb.is-active');
      if (leiste && aktiv && leiste.scrollWidth > leiste.clientWidth) {
        const links = aktiv.offsetLeft - leiste.offsetLeft;
        const rechts = links + aktiv.offsetWidth;
        if (links < leiste.scrollLeft) leiste.scrollLeft = links;
        else if (rechts > leiste.scrollLeft + leiste.clientWidth) leiste.scrollLeft = rechts - leiste.clientWidth;
      }
      this.updateThumbNav(overlay);
    }

    /** Wie Rio: die Miniaturleiste um eine sichtbare Breite weiterscrollen. */
    scrollThumbs(overlay, richtung) {
      const leiste = overlay.querySelector('[data-sf-preview-thumbs]');
      if (!leiste) return;
      leiste.scrollBy({ left: richtung * leiste.clientWidth, behavior: 'smooth' });
    }

    /** Pfeile nur, solange in diese Richtung noch Miniaturen verborgen sind — wie Rio. */
    updateThumbNav(overlay) {
      const leiste = overlay.querySelector('[data-sf-preview-thumbs]');
      const zurueck = overlay.querySelector('[data-sf-preview-thumbscroll="-1"]');
      const weiter = overlay.querySelector('[data-sf-preview-thumbscroll="1"]');
      if (!leiste || !zurueck || !weiter) return;
      zurueck.hidden = Math.floor(leiste.scrollLeft) === 0;
      weiter.hidden = leiste.offsetWidth + Math.ceil(leiste.scrollLeft) >= leiste.scrollWidth;
    }

    /** Anzahl der Bilder in der Vorschau — fuer die Pfeilgrenzen. */
    previewCount(overlay) {
      return overlay.querySelectorAll('[data-sf-preview-slide]').length;
    }

    /** Bild wechseln, ohne den Kaufzustand oder die Auswahl zu beruehren. */
    stepPreview(delta) {
      const overlay = this.previewOverlay();
      if (!overlay || overlay.hidden) return;
      const anzahl = overlay.querySelectorAll('[data-sf-preview-slide]').length;
      if (!anzahl) return;
      const index = Math.min(Math.max(this.trackIndex(overlay) + delta, 0), anzahl - 1);
      if (this.preview) this.preview.index = index;
      this.scrollTrack(overlay, index);
      this.markThumb(overlay, index);
    }

    showPreviewImage(index) {
      const overlay = this.previewOverlay();
      if (!overlay || overlay.hidden) return;
      if (this.preview) this.preview.index = index;
      this.scrollTrack(overlay, index);
      this.markThumb(overlay, index);
    }

    escape(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      })[character]);
    }

    /** "Flasche 2" — aus derselben Vorlage wie die Zeilenbeschriftung. */
    bottleLabel(slot) {
      const row = this.querySelector(`[data-sf-mix-slot="${slot}"] [data-sf-mix-label]`);
      return row?.dataset.multiLabel || ((window.SideFillStrings || {}).colorMixBottleN || 'Flasche [n]').replace('[n]', slot);
    }

    hidePreviewOverlay() {
      const overlay = this.previewOverlay();
      if (overlay) overlay.hidden = true;
    }

    /** Vorschau beenden, ohne etwas zu waehlen — der Kaufzustand war nie beruehrt. */
    endPreview() {
      if (!this.preview) return;
      this.setPreview(null);
      this.render();
    }

    /**
     * Wird die Seite mit ?variant=<ausverkauft> geoeffnet, stuende Flasche 1 sonst auf
     * einer nicht kaufbaren Variante. Dann gilt die erste verfuegbare Farbe — und der
     * Picker folgt, damit auch der normale Warenkorbweg nie eine ausverkaufte Variante
     * sendet.
     */
    guardSoldOutStart() {
      const first = this.variantIds[0] || this.pickerVariantId();
      if (!first) return;
      if (this.isAvailable(first)) {
        // Frischer Aufruf ohne ?variant=: mit der Startfarbe beginnen statt mit der ersten
        // verfuegbaren. Eine schon getroffene Wahl (Register, Adresse) bleibt unberuehrt.
        const start = this.querySelector('[data-sf-mix-slot="1"] [data-sf-mix-start]');
        const fresh = !this.variantIds.length && !new URLSearchParams(window.location.search).has('variant');
        if (!start || !fresh || window.SFEngraving.startColourDone || start.dataset.sfMixVariant === String(first)) return;
        window.SFEngraving.startColourDone = true;
        this.variantIds[0] = start.dataset.sfMixVariant;
        this.syncPicker(start.dataset.sfMixOptionValue);
        return;
      }
      const swatch = this.firstAvailableSwatch();
      if (!swatch) return;
      this.variantIds = this.variantIds.map((id) => (this.isAvailable(id) ? id : swatch.dataset.sfMixVariant));
      this.variantIds[0] = swatch.dataset.sfMixVariant;
      this.syncPicker(swatch.dataset.sfMixOptionValue);
    }

    /**
     * Drives the theme's own variant picker. Matched in JS rather than with an attribute
     * selector, because form IDs and option value IDs are not guaranteed to be
     * selector-safe.
     */
    syncPicker(optionValueId) {
      if (!optionValueId) return;

      const input = Array.from(
        document.querySelectorAll(`input[data-option-position="${this.optionPosition}"]`)
      ).find(
        (candidate) =>
          candidate.getAttribute('form') === this.formId &&
          candidate.value === String(optionValueId)
      );

      // A swatch app may have replaced the picker. The rows still work, only the gallery
      // stops following bottle 1.
      if (!input || input.checked) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /**
     * New bottles take bottle 1's colour, so raising the quantity never asks the customer
     * to choose again. Bottles already changed are left alone, surplus bottles dropped.
     */
    reconcile(quantity) {
      let seed = this.variantIds[0] || this.pickerVariantId();
      if (!this.isAvailable(seed)) seed = this.firstAvailableSwatch()?.dataset.sfMixVariant || seed;

      for (let index = 0; index < quantity; index += 1) {
        if (!this.variantIds[index]) this.variantIds[index] = seed;
      }

      this.variantIds.length = quantity;
    }

    render() {
      const active = this.isActive();
      this.hidden = !active;
      this.dataset.mode = active ? 'bottles' : 'off';

      if (!active) {
        this.variantIds.length = 0;
        this.updateStickyVisibility();
        return;
      }

      const quantity = this.quantity();
      this.reconcile(quantity);

      // Mischhinweis nur, solange der Mengenrabatt ueberhaupt greift (ab 3).
      const hint = this.querySelector('[data-sf-mix-hint]');
      if (hint) hint.hidden = quantity < 3;
      // Ab zwei Flaschen ist die wichtigste Frage "welche Flasche?", bei einer "welche Farbe?".
      this.dataset.bottles = quantity === 1 ? 'single' : 'multi';
      // Mehr Flaschen als Zeilen: dieselben Farben, als Stueckzahl je Farbe gezeichnet.
      const counts = this.countsMode(quantity);
      const rows = this.querySelector('.sf-color-mix__rows');
      if (rows) rows.hidden = counts;
      this.dataset.layout = counts ? 'counts' : 'rows';
      this.renderCounts(counts);
      if (counts) {
        // Die Vorschau gehoert zu einer Flaschenzeile, die es hier nicht gibt.
        if (this.preview) this.setPreview(null);
        this.hidePreviewOverlay();
        this.updateStickyVisibility();
        return;
      }

      // Erst eine Vorschau beenden, deren Flasche weggefallen ist — dann die Ebene pruefen.
      if (this.preview && this.preview.slot > quantity) this.setPreview(null);
      if (!this.preview) this.hidePreviewOverlay();

      this.querySelectorAll('[data-sf-mix-slot]').forEach((row) => {
        // "Farbe" reads better than "Flasche 1" when there is only one.
        const label = row.querySelector('[data-sf-mix-label]');
        if (label && Number(row.dataset.sfMixSlot) === 1) {
          label.textContent =
            quantity === 1
              ? this.dataset.singleLabel || label.dataset.multiLabel
              : label.dataset.multiLabel;
        }

        const index = Number(row.dataset.sfMixSlot);
        const visible = index <= quantity;
        row.hidden = !visible;
        if (!visible) return;

        const selected = this.variantIds[index - 1];
        let selectedName = '';

        const previewHere = this.preview && this.preview.slot === index ? String(this.preview.variantId) : '';
        let previewName = '';
        const previewSoldOut = Boolean(previewHere) && !this.isAvailable(previewHere);
        /*
          Zwei verschiedene Aussagen, zwei verschiedene Rahmen: die aktive
          kaufbare Flasche bleibt blau, die reine Ansicht einer ausverkauften
          Farbe bekommt den gestrichelten Vorschau-Rahmen.
        */
        row.classList.toggle('is-active-preview', Boolean(previewHere) && !previewSoldOut);
        row.classList.toggle('is-preview-only', previewSoldOut);

        row.querySelectorAll('.sf-color-mix__swatch').forEach((swatch) => {
          const available = swatch.dataset.sfMixAvailable !== 'false';
          // Ausverkaufte Farben bekommen nie den Auswahlzustand.
          const isSelected = available && swatch.dataset.sfMixVariant === String(selected);
          swatch.setAttribute('aria-pressed', String(isSelected));
          if (isSelected) selectedName = swatch.dataset.sfMixColor || '';
          // Verfuegbare Farben tragen bereits den Auswahlring; der gestrichelte
          // Vorschau-Ring bleibt den ausverkauften vorbehalten.
          const isPreview = !available && swatch.dataset.sfMixVariant === previewHere;
          swatch.classList.toggle('is-previewing', isPreview);
          if (isPreview) previewName = swatch.dataset.sfMixColor || '';
        });

        /*
          Ist in dieser Zeile eine ausverkaufte Farbe in der Vorschau, zeigt die
          Galerie links diese Farbe. Dann muss sie auch hier oben stehen — sonst
          sieht der Kunde eine rosa Flasche und daneben "Nordic Blue". Die
          gewaehlte Farbe rueckt eine Zeile tiefer, behaelt aber den Haken und
          bleibt das, was gekauft wird.
        */
        const value = row.querySelector('[data-sf-mix-value]');
        if (value) value.textContent = previewName || selectedName;

        const chosen = row.querySelector('[data-sf-mix-selected]');
        if (chosen) {
          chosen.hidden = !previewName || !selectedName;
          chosen.textContent = previewName && selectedName
            ? `${this.dataset.selectedLabel || ((window.SideFillStrings || {}).colorMixSelected || 'Ausgewählt')}: ${selectedName}`
            : '';
        }

        if (previewHere) {
          const previewSwatch = Array.from(row.querySelectorAll('.sf-color-mix__swatch'))
            .find((candidate) => candidate.dataset.sfMixVariant === previewHere);
          if (previewSwatch && this.previewNeedsOverlay(previewSwatch, index)) this.showPreviewOverlay(previewSwatch, index);
          else this.hidePreviewOverlay();
        }

        const hint = row.querySelector('[data-sf-mix-preview]');
        if (hint) {
          hint.hidden = !previewName;
          // Nur noch der Zustand — die Farbe steht jetzt oben in der Zeile.
          hint.textContent = previewName ? (this.dataset.previewLabel || ((window.SideFillStrings || {}).colorMixPreviewOnly || 'Ausverkauft · nur Vorschau')) : '';
        }
      });

      this.renderSticky();
    }

    /**
     * Mobile-Sticky: die gerade bearbeitete Flasche. Liest nur vorhandenen Zustand —
     * die Flasche der aktiven Vorschau, sonst Flasche 1, und deren angesehene oder
     * gewaehlte Variante. Ausverkaufte Vorschau zeigt denselben Hinweis wie die Zeile.
     */
    renderSticky() {
      const sticky = this.sticky || this.querySelector('[data-sf-mix-sticky]');
      if (!sticky) return;
      const quantity = this.quantity();
      const slot = this.preview && this.preview.slot <= quantity ? this.preview.slot : 1;
      const variantId = String(
        this.preview && this.preview.slot === slot ? this.preview.variantId : (this.variantIds[slot - 1] || '')
      );
      const swatch = variantId
        ? this.querySelector(`[data-sf-mix-slot="${slot}"] .sf-color-mix__swatch[data-sf-mix-variant="${CSS.escape(variantId)}"]`)
        : null;
      sticky.dataset.ready = swatch ? 'true' : 'false';
      if (swatch) {
        const soldOut = !this.isAvailable(variantId);
        const bild = this.mediaIndex[String(swatch.dataset.sfMixMediaId)];
        const src = bild ? bild.thumb : (swatch.dataset.sfMixImage || '');
        const img = sticky.querySelector('[data-sf-mix-sticky-image]');
        if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
        sticky.querySelector('[data-sf-mix-sticky-label]').textContent = this.bottleLabel(slot);
        sticky.querySelector('[data-sf-mix-sticky-colour]').textContent = swatch.dataset.sfMixColor || '';
        const status = sticky.querySelector('[data-sf-mix-sticky-status]');
        status.hidden = !soldOut;
        status.textContent = soldOut ? (this.dataset.previewLabel || ((window.SideFillStrings || {}).colorMixPreviewOnly || 'Ausverkauft · nur Vorschau')) : '';
      }
      this.updateStickyVisibility();
    }

    /**
     * Nur Mobile: sichtbar, solange die grosse Galerie oben aus dem Bild ist und
     * "Farben wählen" im Blick ist — Titel in der oberen Bildschirmhaelfte und
     * Farbzeilen, die noch unter die Leiste reichen. Sonst ausgeblendet.
     */
    updateStickyVisibility() {
      const sticky = this.sticky || this.querySelector('[data-sf-mix-sticky]');
      if (!sticky) return;
      let show = false;
      const title = this.querySelector('.sf-color-mix__title');
      const rows = this.querySelector('.sf-color-mix__rows');
      if (!this.hidden && sticky.dataset.ready === 'true' && title && rows &&
          window.matchMedia('(max-width: 699px)').matches) {
        const top = parseFloat(getComputedStyle(sticky).top) || 0;
        const height = sticky.offsetHeight || 97;
        const gallery = this.galleryHost();
        const galleryGone = !gallery || gallery.getBoundingClientRect().bottom <= top;
        const inView = title.getBoundingClientRect().top < window.innerHeight * 0.5 &&
          rows.getBoundingClientRect().bottom > top + height + 24;
        show = galleryGone && inView;
      }
      sticky.classList.toggle('is-visible', show);
    }

    publish() {
      window.SFEngraving.writeColors(this.formId, {
        mode: this.dataset.mode || 'off',
        variantIds: this.variantIds.slice(0, this.quantity()).filter(Boolean)
      });
    }

    /** One cart item per colour, so three identical bottles stay one tidy line. */
    aggregatedItems() {
      const counts = new Map();
      this.variantIds.slice(0, this.quantity()).forEach((variantId) => {
        if (!variantId) return;
        counts.set(variantId, (counts.get(variantId) || 0) + 1);
      });
      return Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
    }

    /**
     * Several colours are several variants, which the native single-variant form cannot
     * post. Engraved orders are left alone — sf-buy-mode sends those to the
     * personalisation view, where each bottle is handled individually in Phase 4.
     */
    onSubmit(event) {
      if (!this.isActive()) return;
      if (event.target !== this.form) return;
      if (window.SFEngraving.readMode(this.formId) === 'engraved') return;

      const items = this.aggregatedItems();
      // A single colour is what the native form already does well.
      if (items.length < 2) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.addMixedToCart(items);
    }

    async addMixedToCart(items) {
      const form = this.form;
      if (!form) return;

      const buttons = Array.from(form.elements).filter((element) => element.type === 'submit');
      const root = (window.Shopify?.routes?.root || '/').toString();
      const base = root.endsWith('/') ? root : `${root}/`;

      buttons.forEach((button) => {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-busy', 'true');
      });
      this.hideError();
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
      );

      try {
        const response = await fetch(`${base}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            sections: sections.join(','),
            sections_url: `${base}variants/${this.pickerVariantId()}`
          })
        });

        const json = await response.json();

        if (!response.ok) {
          this.showError(json?.description);
          form.dispatchEvent(
            new CustomEvent('cart:error', { bubbles: true, detail: { error: json?.description } })
          );
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        if (
          window.themeVariables?.settings?.cartType === 'page' ||
          window.themeVariables?.settings?.pageType === 'cart'
        ) {
          window.location.href = `${base}cart`;
          return;
        }

        const cart = await (await fetch(`${base}cart.js`)).json();
        cart.sections = json.sections;
        const onSuccessDo = form.elements.on_success?.value || null;

        form.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: json.items || [json], cart, onSuccessDo }
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo, cart }
          })
        );
      } catch (error) {
        this.showError();
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error } }));
      } finally {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        buttons.forEach((button) => {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-busy');
        });
      }
    }

    showError(message) {
      if (!this.errorNode) return;
      this.errorNode.textContent =
        message || ((window.SideFillStrings || {}).cartUpdateError || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte noch einmal versuchen.');
      this.errorNode.hidden = false;
    }

    hideError() {
      if (!this.errorNode) return;
      this.errorNode.hidden = true;
      this.errorNode.textContent = '';
    }
  }

  if (!customElements.get('sf-color-mix')) {
    customElements.define('sf-color-mix', SfColorMix);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-engraving-choice"] && !Shopify.designMode) return;
  try {
    /**
   * Shared Flow A state, keyed by product form ID rather than kept in the DOM, because
   * the theme replaces the buy buttons on every variant change and replaces the whole
   * sticky bar wholesale. Elements re-read the registry when they reconnect.
   *
   * Extended field by field so this file and sf-color-mix can be loaded in either order
   * without one overwriting the other's half.
   */
  window.SFEngraving = window.SFEngraving || {};
  window.SFEngraving.modes = window.SFEngraving.modes || new Map();
  window.SFEngraving.colors = window.SFEngraving.colors || new Map();
  window.SFEngraving.handoverKey = window.SFEngraving.handoverKey || 'sf:flow-a:handover';

  window.SFEngraving.readMode = window.SFEngraving.readMode || function (formId) {
    return window.SFEngraving.modes.get(formId) || 'none';
  };

  window.SFEngraving.writeMode = window.SFEngraving.writeMode || function (formId, mode) {
    window.SFEngraving.modes.set(formId, mode);
    document.dispatchEvent(new CustomEvent('sf:engraving-mode', { detail: { formId, mode } }));
  };

  /** @returns {{ mode: string, variantIds: string[] }} */
  window.SFEngraving.readColors = window.SFEngraving.readColors || function (formId) {
    return window.SFEngraving.colors.get(formId) || { mode: 'off', variantIds: [] };
  };

  window.SFEngraving.writeColors = window.SFEngraving.writeColors || function (formId, value) {
    window.SFEngraving.colors.set(formId, value);
    document.dispatchEvent(new CustomEvent('sf:color-mix', { detail: { formId, ...value } }));
  };

  /**
   * Tells whether an element belongs to a given product form, whether it sits inside the
   * form or is only associated with it through a `form` attribute. Prestige puts the
   * quantity field outside the form, so DOM containment alone is not enough.
   *
   * @param {Element | null} element
   * @param {string} formId
   */
  window.SFEngraving.belongsToForm = window.SFEngraving.belongsToForm || function (element, formId) {
    if (!element || !formId) return false;
    if (element.getAttribute && element.getAttribute('form') === formId) return true;
    const owner = element.closest ? element.closest('form') : null;
    return Boolean(owner && owner.id === formId);
  };

  class SfEngravingChoice extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.hint = this.querySelector('[data-sf-engraving-hint]');
      this.controller = new AbortController();

      const known = window.SFEngraving.readMode(this.formId);
      // Kästchen (Februar-Aufbau): angekreuzt heisst «Mit Gravur», sonst «Ohne».
      const box = this.querySelector('input[type="checkbox"][data-sf-engraving-mode]');
      if (box) {
        box.checked = known === 'engraved';
      } else {
        const input = this.querySelector(`[data-sf-engraving-mode][value="${known}"]`);
        if (input) input.checked = true;
      }
      this.apply(known, false);

      // Link-Darstellung: Gravurmodus nur für die Dauer des Namensdialogs.
      const moreLink = this.querySelector('[data-sf-engraving-link]');
      if (moreLink) {
        moreLink.addEventListener('click', () => this.openFromLink(), { signal: this.controller.signal });
      }

      this.addEventListener(
        'change',
        (event) => {
          if (!event.target.matches('[data-sf-engraving-mode]')) return;
          const mode =
            event.target.type === 'checkbox'
              ? (event.target.checked ? 'engraved' : 'none')
              : event.target.value;
          this.apply(mode, true);
        },
        { signal: this.controller.signal }
      );
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    /**
     * Öffnet den Namensdialog wie der Knopf «Jetzt personalisieren» (gleicher Ablauf, gleiche
     * Übergabe von Farben und Menge). Schliesst sich der Dialog, gilt wieder «ohne Gravur».
     */
    openFromLink() {
      const id = CSS.escape(this.formId);
      const cta = document.querySelector(`sf-buy-mode[data-form-id="${id}"] [data-sf-personalize] a`);
      if (!cta) return;
      const dialog = document.querySelector(`sf-engraving-modal[data-form-id="${id}"] [data-sf-dialog]`);
      this.apply('engraved', true);
      cta.click();
      // Zurück auf «ohne Gravur», sobald der Dialog zu ist. Das open-Attribut verschwindet beim
      // Schliessen sofort; das close-Ereignis kommt nicht in jeder Umgebung zuverlässig an.
      if (dialog && dialog.open) {
        const watcher = new MutationObserver(() => {
          if (dialog.open) return;
          watcher.disconnect();
          this.apply('none', true);
        });
        watcher.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      } else if (dialog) {
        // Dialog konnte nicht öffnen: Seite nicht im Gravurmodus stehen lassen.
        this.apply('none', true);
      }
    }

    apply(mode, broadcast) {
      const normalized = mode === 'engraved' ? 'engraved' : 'none';
      this.dataset.mode = normalized;
      if (this.hint) this.hint.hidden = normalized !== 'engraved';
      if (broadcast) window.SFEngraving.writeMode(this.formId, normalized);
      else window.SFEngraving.modes.set(this.formId, normalized);
    }
  }

  /**
   * Wraps the add-to-cart button and the "Jetzt personalisieren" link, and shows exactly
   * one of them. Also keeps the link's href carrying the current selection so the
   * personalisation view (Phase 4) can restore it without asking again.
   */
  class SfBuyMode extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.cta = this.querySelector('[data-sf-personalize]');
      this.cfg = this.cta ? this.cta.dataset : {};
      this.link = this.cta ? this.cta.querySelector('a') : null;

      this.controller = new AbortController();
      // options darf ein Boolean sein — { ...true } waere {} und wuerde capture verschlucken.
      const on = (target, type, handler, options) => {
        const opts = typeof options === 'boolean' ? { capture: options } : { ...(options || {}) };
        target.addEventListener(type, handler, { ...opts, signal: this.controller.signal });
      };

      on(document, 'sf:engraving-mode', (event) => {
        if (event.detail.formId !== this.formId) return;
        this.render(event.detail.mode);
      });

      on(document, 'sf:color-mix', (event) => {
        if (event.detail.formId !== this.formId) return;
        this.syncLink();
      });

      /*
       * Bound to `document`, not to the form: the quantity field lives outside the form
       * and is only associated with it, so its events never travel through the form.
       */
      const onFieldChange = (event) => {
        const target = event.target;
        if (!target || !window.SFEngraving.belongsToForm(target, this.formId)) return;
        this.syncLink();
      };
      on(document, 'input', onFieldChange);
      on(document, 'change', onFieldChange);

      // Der Mengen-Stepper feuert kein Event (input.stepUp), deshalb der Klick.
      on(document, 'click', (event) => {
        const stepper = event.target.closest?.('quantity-selector');
        if (!stepper) return;
        const field = stepper.querySelector('[name="quantity"]');
        if (!window.SFEngraving.belongsToForm(field, this.formId)) return;
        requestAnimationFrame(() => this.syncLink());
      });

      on(document, 'variant:change', (event) => {
        if (event.detail?.formId && event.detail.formId !== this.formId) return;
        this.syncLink();
      });

      /**
       * The add-to-cart button is only hidden, so the form could still be submitted with
       * Enter from the quantity field. In engraving mode that would silently buy an
       * unengraved bottle, so the submit opens the personalisation dialog instead.
       */
      on(
        document,
        'submit',
        (event) => {
          if (event.target !== this.form) return;
          if (window.SFEngraving.readMode(this.formId) !== 'engraved') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.personalize(this.link);
        },
        true
      );

      /*
       * Der Knopf bleibt ein echter Link auf die eigene Personalisierungsansicht.
       * Mit JavaScript und <dialog> wird daraus ein Overlay auf derselben Seite —
       * ohne beides fuehrt derselbe Klick weiterhin irgendwohin Sinnvolles.
       */
      if (this.link) {
        on(this.link, 'click', (event) => {
          // In einem neuen Tab oeffnen bleibt Sache des Browsers: Cmd/Strg, Shift,
          // Alt und die mittlere Maustaste duerfen nicht abgefangen werden. Die
          // Uebergabe steht dann im Query-String und in sessionStorage bereit.
          const eigenerWeg =
            event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;

          if (eigenerWeg || !this.canOpenDialog()) {
            this.commitHandover();
            return;
          }
          event.preventDefault();
          this.personalize(this.link);
        });
      }

      this.render(window.SFEngraving.readMode(this.formId));
      this.syncLink();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    /** Resolved on demand — the theme replaces the form on a full re-render. */
    get form() {
      return document.forms[this.formId] || null;
    }

    /** Ohne Dialog auf der Seite bleibt der Seitenwechsel die richtige Antwort. */
    canOpenDialog() {
      if (typeof HTMLDialogElement === 'undefined') return false;
      return Boolean(
        document.querySelector(`sf-engraving-modal[data-form-id="${CSS.escape(this.formId)}"]`)
      );
    }

    /**
     * Oeffnet die Personalisierung. Die Uebergabe wird trotzdem geschrieben: sie
     * kostet nichts und rettet den Fall, dass der Kunde den Link in einem neuen Tab
     * oeffnet.
     */
    personalize(opener) {
      this.commitHandover();
      if (!this.canOpenDialog()) {
        if (this.link) window.location.assign(this.link.getAttribute('href'));
        return;
      }
      document.dispatchEvent(
        new CustomEvent('sf:personalize-open', {
          detail: { formId: this.formId, opener: opener || null }
        })
      );
    }

    render(mode) {
      this.classList.toggle('is-mode-engraved', mode === 'engraved');
    }

    /** @returns {{ quantity: number, variantId: string }} */
    selection() {
      const form = this.form;
      const rawQuantity = Number(form?.elements?.quantity?.value || 1);
      const quantity = Math.max(1, Math.round(rawQuantity) || 1);
      const variantId = String(form?.elements?.id?.value || this.cfg.defaultVariantId || '');
      return { quantity, variantId };
    }

    /**
     * Handover contract for Phase 4 — the personalisation view reads either the query
     * string or sessionStorage under `sf:flow-a:handover`. One entry per bottle, in
     * order, because the engraving belongs to a specific bottle.
     */
    payload() {
      const { quantity, variantId } = this.selection();
      const mix = window.SFEngraving.readColors(this.formId);

      let variantIds = variantId ? Array(quantity).fill(variantId) : [];

      if (Array.isArray(mix.variantIds) && mix.variantIds.length) {
        variantIds = Array.from({ length: quantity }, (_, index) =>
          mix.variantIds[index] || variantId || ''
        ).filter(Boolean);
      }

      return {
        v: 1,
        productId: Number(this.cfg.productId || 0),
        productHandle: this.cfg.productHandle || '',
        quantity,
        // Read off the data rather than a flag, so it cannot drift from the colours.
        colorMode: new Set(variantIds).size > 1 ? 'mixed' : 'same',
        variantIds,
        createdAt: new Date().toISOString()
      };
    }

    syncLink() {
      if (!this.link) return;
      const base = this.cfg.personalizeUrl || this.link.getAttribute('href') || '';
      if (!base) return;

      const payload = this.payload();
      let url;
      try {
        url = new URL(base, window.location.href);
      } catch (error) {
        return;
      }
      url.searchParams.set('sf_qty', String(payload.quantity));
      if (payload.variantIds.length) {
        url.searchParams.set('sf_variants', payload.variantIds.join(','));
      }
      this.link.setAttribute('href', url.pathname + url.search + url.hash);
    }

    commitHandover() {
      this.syncLink();
      try {
        sessionStorage.setItem(
          window.SFEngraving.handoverKey,
          JSON.stringify(this.payload())
        );
      } catch (error) {
        /* Private mode or storage disabled — the query string still carries the selection. */
      }
    }
  }

  if (!customElements.get('sf-engraving-choice')) {
    customElements.define('sf-engraving-choice', SfEngravingChoice);
  }

  if (!customElements.get('sf-buy-mode')) {
    customElements.define('sf-buy-mode', SfBuyMode);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-engraving-modal"] && !Shopify.designMode) return;
  try {
    window.SFEngraving = window.SFEngraving || {};

  /**
   * Der Dialog. Er hält selbst keinen Zustand — beim Öffnen liest er die Auswahl von
   * der Produktseite, beim Schliessen gibt er den Fokus dorthin zurück, wo der Kunde
   * war. Weil nie navigiert wird, bleiben Menge, Farben und Scrollposition ohnehin
   * erhalten; es gibt nichts wiederherzustellen.
   */
  class SfEngravingModal extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.dialog = this.querySelector('[data-sf-dialog]');
      this.panel = this.querySelector('sf-engraving');
      this.opener = null;

      this.controller = new AbortController();
      const on = (target, type, handler) =>
        target.addEventListener(type, handler, { signal: this.controller.signal });

      on(this, 'click', (event) => {
        if (event.target.closest('[data-sf-dialog-close]')) this.close();
      });

      // Klick auf den abgedunkelten Hintergrund schliesst — das <dialog>-Element
      // selbst ist der Rahmen, der Inhalt liegt im __panel darin.
      on(this.dialog, 'click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      // Escape läuft über das native `cancel`, damit auch der Browser-Weg aufräumt.
      on(this.dialog, 'close', () => this.afterClose());

      on(this, 'sf:panel-close', () => this.close());
      on(this, 'sf:panel-added', () => this.close());

      // Öffnen wird von sf-buy-mode ausgelöst, das den Personalisieren-Knopf besitzt.
      on(document, 'sf:personalize-open', (event) => {
        if (event.detail?.formId && event.detail.formId !== this.formId) return;
        this.open(event.detail?.opener || null);
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      document.documentElement.classList.remove('sf-modal-open');
    }

    /** Resolved on demand — das Theme ersetzt das Formular bei einem Rerender. */
    get form() {
      return document.forms[this.formId] || null;
    }

    /**
     * Eine Flasche je Position, in Flaschenreihenfolge. Erste Wahl sind die Farben
     * aus sf-color-mix; fehlen sie (etwa weil das Produkt nur eine Farbe hat), wird
     * die Menge mit der Variante des nativen Pickers aufgefüllt.
     *
     * @returns {Array<{id: string}>}
     */
    selection() {
      const form = this.form;
      const rawQuantity = Number(form?.elements?.quantity?.value || 1);
      const quantity = Math.max(1, Math.round(rawQuantity) || 1);
      const fallbackId = String(form?.elements?.id?.value || '');

      const mix = window.SFEngraving.readColors
        ? window.SFEngraving.readColors(this.formId)
        : { variantIds: [] };
      const chosen = Array.isArray(mix.variantIds) ? mix.variantIds : [];

      return Array.from({ length: quantity }, (_, index) => ({
        id: String(chosen[index] || fallbackId || '')
      })).filter((entry) => entry.id);
    }

    open(opener) {
      if (!this.dialog || this.dialog.open) return;
      this.opener = opener || document.activeElement;

      this.panel?.load(this.selection());

      document.documentElement.classList.add('sf-modal-open');

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        // Uralte Browser ohne <dialog>: der Personalisieren-Knopf bleibt ein Link
        // auf die eigene Ansicht, hier passiert dann schlicht nichts.
        this.dialog.setAttribute('open', '');
      }

      // Nicht das erste Eingabefeld fokussieren: auf dem Handy zöge das sofort die
      // Tastatur hoch und verdeckte die Vorschau. Der Dialog selbst reicht.
      const body = this.querySelector('.sf-modal__body');
      if (body) body.scrollTop = 0;

      this.dispatchEvent(new CustomEvent('sf:modal-open', { bubbles: true }));
    }

    close() {
      if (!this.dialog) return;
      if (this.dialog.open && typeof this.dialog.close === 'function') {
        this.dialog.close();
        return;
      }
      this.dialog.removeAttribute('open');
      this.afterClose();
    }

    afterClose() {
      document.documentElement.classList.remove('sf-modal-open');
      // Zurück an dieselbe Stelle der Produktseite — inklusive Fokus.
      if (this.opener && document.contains(this.opener)) {
        try {
          this.opener.focus({ preventScroll: true });
        } catch (error) {
          this.opener.focus();
        }
      }
      this.opener = null;
      this.dispatchEvent(new CustomEvent('sf:modal-close', { bubbles: true }));
    }
  }

  if (!customElements.get('sf-engraving-modal')) {
    customElements.define('sf-engraving-modal', SfEngravingModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-engraving-panel"] && !Shopify.designMode) return;
  try {
    /**
   * Gemeinsamer Flow-A-Zustand. Feldweise erweitert, damit dieses Snippet,
   * sf-color-mix und sf-engraving-choice in beliebiger Reihenfolge geladen werden
   * können, ohne sich gegenseitig zu überschreiben.
   */
  window.SFEngraving = window.SFEngraving || {};
  window.SFEngraving.handoverKey = window.SFEngraving.handoverKey || 'sf:flow-a:handover';
  /** Gravurtexte je Formular, damit Schliessen und Öffnen nichts verliert. */
  window.SFEngraving.texts = window.SFEngraving.texts || new Map();

  class SfEngraving extends HTMLElement {
    connectedCallback() {
      this.panelMode = this.dataset.mode || 'page';
      this.formId = this.dataset.formId || '';
      this.maxBottles = Number(this.dataset.maxBottles || 10);
      this.maxCharacters = Number(this.dataset.maxCharacters || 10);
      this.feeVariantId = this.dataset.feeVariantId || '';
      this.feeCents = Number(this.dataset.feeCents || 0);
      this.flowVersion = this.dataset.flowVersion || '';

      this.shell = this.querySelector('[data-sf-shell]');
      this.empty = this.querySelector('[data-sf-empty]');
      this.previewImage = this.querySelector('[data-sf-preview-image]');
      this.previewText = this.querySelector('[data-sf-preview-text]');
      this.previewLabel = this.querySelector('[data-sf-preview-label]');
      this.previewColor = this.querySelector('[data-sf-preview-color]');
      this.recap = this.querySelector('[data-sf-recap]');
      this.chips = this.querySelector('[data-sf-chips]');
      this.summary = this.querySelector('[data-sf-summary]');
      this.footerCounts = this.querySelector('[data-sf-footer-counts]');
      this.footerTotal = this.querySelector('[data-sf-footer-total]');
      this.addButton = this.querySelector('[data-sf-add]');
      this.errorNode = this.querySelector('[data-sf-engrave-error]');

      this.catalog = this.readJson('[data-sf-engraving-variants]') || { variants: {} };

      this.bottles = [];
      this.engravings = [];
      this.activeIndex = 0;

      this.controller = new AbortController();
      const on = (target, type, handler) =>
        target.addEventListener(type, handler, { signal: this.controller.signal });

      on(this, 'input', (event) => {
        const input = event.target.closest('[data-sf-engrave-input]');
        if (!input) return;
        this.setEngraving(Number(input.dataset.sfEngraveInput) - 1, input.value);
      });

      // Der Fokus bewegt die Vorschau, nicht ein "Weiter"-Knopf.
      on(this, 'focusin', (event) => {
        const input = event.target.closest('[data-sf-engrave-input]');
        if (!input) return;
        this.setActive(Number(input.dataset.sfEngraveInput) - 1);
        this.keepFieldVisible(input);
      });

      on(this, 'click', (event) => {
        const chip = event.target.closest('[data-sf-chip]');
        if (chip) {
          const index = Number(chip.dataset.sfChip);
          this.setActive(index);
          this.querySelector(`[data-sf-engrave-input="${index + 1}"]`)?.focus();
          return;
        }
        if (event.target.closest('[data-sf-close-panel]')) {
          this.dispatchEvent(new CustomEvent('sf:panel-close', { bubbles: true }));
          return;
        }
        if (event.target.closest('[data-sf-bulk-apply]')) return this.applyBulk();
        if (event.target.closest('[data-sf-add]')) this.addToCart();
      });

      // Fehlt die gerade Ansicht für ein Chip-Bild, auf die nächste Quelle wechseln.
      // error blubbert nicht — deshalb in der Capture-Phase am Container.
      this.chips?.addEventListener('error', (event) => {
        const img = event.target;
        if (!(img instanceof HTMLImageElement) || !img.dataset.fallback) return;
        const next = img.dataset.fallback;
        img.dataset.fallback = '';
        img.src = next;
      }, { capture: true, signal: this.controller.signal });

      // Auf der eigenen Seite gibt es niemanden, der load() aufruft.
      if (this.panelMode === 'page') this.load(this.readHandover());
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    readJson(selector) {
      const node = this.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    /**
     * Der einzige Eintrittspunkt für eine Auswahl — vom Dialog beim Öffnen, auf der
     * eigenen Seite beim Verbinden. Bereits eingegebene Texte bleiben je Position
     * erhalten, damit Schliessen und Wiederöffnen nichts verliert.
     *
     * @param {Array<{id: string}>} bottles
     */
    load(bottles) {
      this.bottles = (Array.isArray(bottles) ? bottles : [])
        .map((entry) => {
          const id = String(entry && entry.id != null ? entry.id : entry);
          const known = this.catalog.variants[id];
          return known ? { id, ...known } : null;
        })
        .filter(Boolean);

      const remembered = this.rememberedTexts();
      this.engravings = this.bottles.map((_, index) => remembered[index] || '');
      this.activeIndex = 0;

      const hasBottles = this.bottles.length > 0;
      if (this.shell) this.shell.hidden = !hasBottles;
      if (this.empty) this.empty.hidden = hasBottles;
      if (!hasBottles) return;

      this.ensureFields(this.bottles.length);
      const bulk = this.querySelector('[data-sf-bulk]');
      if (bulk) bulk.hidden = this.bottles.length < Number(this.dataset.bulkFrom || 4);
      const bulkResult = this.querySelector('[data-sf-bulk-result]');
      if (bulkResult) bulkResult.textContent = '';

      this.renderFields();
      this.renderChips();
      this.renderRecap();
      this.setActive(0);
      this.renderSummary();
      this.syncValidity();
      this.hideError();
    }

    /**
     * Im Markup stehen nur die ersten Namensfelder. Für jede weitere Flasche wird das
     * erste Feld kopiert und neu nummeriert — so bleiben Aufbau, Regeln und
     * Beschriftung an einer Stelle.
     */
    ensureFields(count) {
      const list = this.querySelector('.sf-engraving__fields');
      const template = list?.querySelector('[data-sf-field="1"]');
      const firstInput = template?.querySelector('[data-sf-engrave-input]');
      if (!list || !template || !firstInput) return;
      const idBase = firstInput.id.replace(/-1$/, '');
      const metaBase = idBase.replace('SfEngraving-', 'SfEngravingMeta-');
      const labelTemplate = this.dataset.fieldLabelTemplate || 'Flasche [index]';

      let have = list.querySelectorAll('[data-sf-field]').length;
      while (have < count) {
        have += 1;
        const field = template.cloneNode(true);
        field.dataset.sfField = String(have);
        field.hidden = true;
        field.classList.remove('is-active', 'is-complete');

        const input = field.querySelector('[data-sf-engrave-input]');
        input.id = `${idBase}-${have}`;
        input.dataset.sfEngraveInput = String(have);
        input.value = '';
        input.setAttribute('aria-describedby', `${metaBase}-${have}`);
        field.querySelector('.sf-engraving__field-meta').id = `${metaBase}-${have}`;
        field.querySelector('.sf-engraving__field-head').setAttribute('for', input.id);
        field.querySelector('.sf-engraving__field-label').textContent = labelTemplate.replace('[index]', have);
        list.append(field);
      }
    }

    /**
     * Verteilt eine Liste auf die Flaschen: Zeile 1 auf Flasche 1 und so weiter.
     * Flaschen ohne Zeile behalten ihren Text. Zu lange oder ungültige Namen werden
     * nicht stillschweigend gekürzt — das Feld zeigt sie als Fehler an.
     */
    applyBulk() {
      const input = this.querySelector('[data-sf-bulk-input]');
      if (!input) return;
      const lines = String(input.value || '').split(/\r?\n/).map((line) => line.trim());
      while (lines.length && !lines[lines.length - 1]) lines.pop();
      if (!lines.length) return;

      const used = Math.min(lines.length, this.bottles.length);
      for (let index = 0; index < used; index += 1) this.engravings[index] = lines[index];

      this.rememberTexts();
      this.renderFields();
      this.renderChips();
      this.renderSummary();
      this.syncValidity();
      this.hideError();

      const result = this.querySelector('[data-sf-bulk-result]');
      if (result) {
        const extra = lines.length - used;
        result.textContent = (this.dataset.bulkResult || '[count]').replace('[count]', used) +
          (extra > 0 ? ` · ${(this.dataset.bulkExtra || '[count]').replace('[count]', extra)}` : '');
      }
    }

    /**
     * Der Weg per E-Mail, ab vielen Flaschen. Die Mail nennt die Stückzahl je Farbe
     * und, solange sie in eine Mail-Adresse passt, die Liste der Flaschen mit den
     * bereits eingetragenen Namen.
     */
    renderMail() {
      const box = this.querySelector('[data-sf-mail]');
      const link = box?.querySelector('[data-sf-mail-link]');
      if (!box || !link) return;
      const show = this.bottles.length >= Number(this.dataset.mailFrom || 11);
      box.hidden = !show;
      if (!show) return;

      const counts = new Map();
      this.bottles.forEach((bottle) => counts.set(bottle.color, (counts.get(bottle.color) || 0) + 1));
      const lines = [this.dataset.mailIntro || '', ...Array.from(counts, ([color, count]) => `${count} × ${color}`), ''];
      lines.push(this.dataset.mailNames || '');
      // Sehr lange mailto-Adressen schneiden manche Mailprogramme ab.
      if (this.bottles.length <= 60) {
        this.bottles.forEach((bottle, index) => {
          lines.push(`${index + 1}. ${bottle.color}: ${String(this.engravings[index] || '').trim()}`);
        });
      }
      link.href = `mailto:${this.dataset.orderEmail || ''}?subject=${encodeURIComponent(this.dataset.mailSubject || '')}&body=${encodeURIComponent(lines.join('\n'))}`;
    }

    /** @returns {string[]} */
    rememberedTexts() {
      if (!this.formId) return this.engravings.slice();
      const stored = window.SFEngraving.texts.get(this.formId);
      return Array.isArray(stored) ? stored.slice() : [];
    }

    rememberTexts() {
      if (!this.formId) return;
      window.SFEngraving.texts.set(this.formId, this.engravings.slice());
    }

    forgetTexts() {
      if (this.formId) window.SFEngraving.texts.delete(this.formId);
      this.engravings = this.bottles.map(() => '');
    }

    /**
     * Nur für den Seitenmodus. Query-String zuerst, damit ein geteilter oder neu
     * geladener Link weiter funktioniert; sessionStorage als Rückfall. Unbekannte
     * Varianten-IDs werden verworfen statt geglaubt.
     */
    readHandover() {
      const params = new URLSearchParams(window.location.search);
      let ids = (params.get('sf_variants') || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      if (!ids.length) {
        try {
          const stored = JSON.parse(sessionStorage.getItem(window.SFEngraving.handoverKey) || 'null');
          if (stored && Array.isArray(stored.variantIds)) ids = stored.variantIds.map(String);
        } catch (error) {
          ids = [];
        }
      }

      const quantity = Number(params.get('sf_qty') || ids.length || 0);
      if (quantity > 0) ids = ids.slice(0, quantity);

      return ids.map((id) => ({ id }));
    }

    /** Leer heisst: diese Flasche wird nicht graviert — das ist erlaubt. */
    isEngraved(value) {
      return String(value || '').trim().length > 0;
    }

    /** Dieselbe Regel wie auf der Produktseite und im Warenkorb. */
    isValid(value) {
      const trimmed = String(value || '').trim();
      if (trimmed.length === 0) return true;
      return trimmed.length <= this.maxCharacters && /^[\p{L}\p{N} .&+\-]+$/u.test(trimmed);
    }

    engravedCount() {
      return this.engravings.filter((value) => this.isEngraved(value) && this.isValid(value)).length;
    }

    setEngraving(index, rawValue) {
      this.engravings[index] = String(rawValue || '').slice(0, this.maxCharacters);
      this.rememberTexts();
      this.setActive(index);
      this.syncField(index);
      this.renderChips();
      this.renderSummary();
      this.syncValidity();
      this.hideError();
    }

    setActive(index) {
      this.activeIndex = Math.min(Math.max(index, 0), Math.max(this.bottles.length - 1, 0));
      this.renderPreview();
      this.renderChips();
      this.querySelectorAll('[data-sf-field]').forEach((field) => {
        field.classList.toggle('is-active', Number(field.dataset.sfField) - 1 === this.activeIndex);
      });
    }

    /**
     * Die Fussleiste steht fest am unteren Rand. Liegt das gerade fokussierte Feld
     * dahinter — auf dem Handy oft, wenn die Tastatur aufgeht — wird es sichtbar
     * gescrollt. Nur dann, nicht bei jedem Fokus.
     */
    keepFieldVisible(input) {
      const actions = this.querySelector('.sf-engraving__actions');
      if (!actions) return;
      requestAnimationFrame(() => {
        const field = input.getBoundingClientRect();
        const bar = actions.getBoundingClientRect();
        if (field.bottom > bar.top && field.top < bar.bottom) {
          input.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    }

    renderFields() {
      this.querySelectorAll('[data-sf-field]').forEach((field) => {
        const index = Number(field.dataset.sfField) - 1;
        const bottle = this.bottles[index];
        field.hidden = !bottle;
        if (!bottle) return;

        const color = field.querySelector('[data-sf-field-color]');
        if (color) color.textContent = bottle.color;
        this.syncField(index);
      });
    }

    syncField(index) {
      const field = this.querySelector(`[data-sf-field="${index + 1}"]`);
      if (!field) return;

      const value = this.engravings[index] || '';
      const input = field.querySelector('[data-sf-engrave-input]');
      const count = field.querySelector('[data-sf-field-count]');
      const error = field.querySelector('[data-sf-field-error]');
      const valid = this.isValid(value);

      if (input && input.value !== value) input.value = value;
      if (count) count.textContent = `${value.length} / ${this.maxCharacters}`;
      if (error) error.textContent = value && !valid ? this.dataset.labelInvalid : '';
      field.classList.toggle('is-complete', this.isEngraved(value) && valid);
      // Blau heisst "hier bin ich gerade", gruen nur ein kleiner Haken — keine
      // Validierungsoptik, leere Felder sind ausdruecklich erlaubt.
      field.classList.toggle('is-active', index === this.activeIndex);

      if (index === this.activeIndex) this.renderPreview();
    }

    /**
     * Die gerade Rückansicht zuerst, dann die 45°-Ansicht als technischer Rückfall,
     * zuletzt die Produktaufnahme. Die Kette läuft über onerror, damit eine fehlende
     * Datei die Vorschau nie leer lässt.
     *
     * @returns {Array<{src: string, kind: 'flat' | 'back' | 'front'}>}
     */
    previewSources(bottle) {
      const chain = [];
      if (bottle.flatImage) chain.push({ src: bottle.flatImage, kind: 'flat' });
      if (bottle.backImage) chain.push({ src: bottle.backImage, kind: 'back' });
      if (bottle.fallbackImage) chain.push({ src: bottle.fallbackImage, kind: 'front' });
      return chain;
    }

    /**
     * Auf der geraden Rückansicht steht die Gravur waagrecht. Die Drehung aus den
     * Einstellungen war ein Behelf für die perspektivische 45°-Ansicht und gilt nur,
     * solange diese als Rückfall angezeigt wird.
     */
    applySource(kind) {
      if (this.previewImage) this.previewImage.dataset.sfSource = kind;
      if (!this.previewText) return;
      const y = this.previewText.dataset.sfTextY || '840';
      const angle = kind === 'back' ? Number(this.catalog.fallbackRotation || 0) : 0;
      this.previewText.setAttribute('transform', `rotate(${angle} 540 ${y})`);
    }

    renderPreview() {
      const bottle = this.bottles[this.activeIndex];
      if (!bottle) return;

      if (this.previewImage) {
        const chain = this.previewSources(bottle);
        const wanted = chain[0] ? chain[0].src : '';
        if (this.previewImage.getAttribute('href') !== wanted) {
          let step = 0;
          this.previewImage.onerror = () => {
            step += 1;
            if (!chain[step]) return;
            this.applySource(chain[step].kind);
            this.previewImage.setAttribute('href', chain[step].src);
          };
          this.applySource(chain[0] ? chain[0].kind : 'front');
          this.previewImage.setAttribute('href', wanted);
        }
      }

      if (this.previewText) {
        this.previewText.textContent = this.engravings[this.activeIndex] || '';
        // Hell auf dunklen Flaschen, dunkel auf hellen — sonst verschwindet die Gravur.
        if (bottle.textColor) this.previewText.setAttribute('fill', bottle.textColor);
        this.fitPreviewText();
      }

      if (this.previewLabel) {
        this.previewLabel.textContent =
          this.bottles.length > 1
            ? ((window.SideFillStrings || {}).engravingBottleOf || 'Flasche [n] von [total] ·').replace('[n]', this.activeIndex + 1).replace('[total]', this.bottles.length)
            : ((window.SideFillStrings || {}).engravingYourSideFill || 'Deine SideFill');
      }
      if (this.previewColor) this.previewColor.textContent = bottle.color;
    }

    /** Text stauchen statt über die Flasche laufen lassen. */
    fitPreviewText() {
      const node = this.previewText;
      if (!node) return;

      node.removeAttribute('textLength');
      node.removeAttribute('lengthAdjust');

      const max = Number(this.dataset.textMaxWidth || 380);
      let width = 0;
      try {
        width = node.getBBox().width;
      } catch (error) {
        return; // verborgenes Element — nichts zu messen
      }

      if (width > max) {
        node.setAttribute('textLength', String(max));
        node.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      }
    }

    renderRecap() {
      if (!this.recap) return;
      if (this.panelMode !== 'modal' || !this.bottles.length) {
        this.recap.textContent = '';
        return;
      }
      // Nur die Zahl: die Farben stehen ohnehin an jeder Flasche und in der Vorschau.
      const count = this.bottles.length;
      this.recap.textContent = (count === 1 ? ((window.SideFillStrings || {}).engravingSelectedOne || '[count] SideFill ausgewählt') : ((window.SideFillStrings || {}).engravingSelectedMany || '[count] SideFills ausgewählt')).replace('[count]', count);
    }

    /**
     * Wird bei jedem Tastendruck aufgerufen. Deshalb wird das Markup nur dann neu
     * gebaut, wenn sich die Flaschen selbst geändert haben — sonst werden bloss die
     * Klassen umgeschaltet. Ein innerHTML je Zeichen würde die Bilder neu anfordern
     * und den gerade angeklickten Knopf mitten im Ereignis unter der Hand austauschen.
     */
    renderChips() {
      if (!this.chips) return;

      if (this.bottles.length < 2) {
        if (this.chips.childElementCount) this.chips.innerHTML = '';
        this.chips.dataset.signature = '';
        return;
      }

      const signature = this.bottles.map((bottle) => bottle.id).join(',');
      if (this.chips.dataset.signature !== signature) {
        this.chips.dataset.signature = signature;
        this.chips.innerHTML = this.bottles
          .map((bottle, index) => {
            const sources = this.previewSources(bottle);
            const image = sources[0] ? sources[0].src : '';
            const fallback = sources[1] ? sources[1].src : '';
            return `<button type="button" class="sf-engraving__chip" data-sf-chip="${index}" aria-label="${((window.SideFillStrings || {}).engravingBottleN || 'Flasche [n]').replace('[n]', index + 1)}, ${this.escape(bottle.color)}"><img src="${this.escape(image)}" data-fallback="${this.escape(fallback)}" alt=""><span class="sf-engraving__chip-number" aria-hidden="true">${index + 1}</span></button>`;
          })
          .join('');
      }

      this.chips.querySelectorAll('[data-sf-chip]').forEach((chip) => {
        const index = Number(chip.dataset.sfChip);
        chip.classList.toggle('is-active', index === this.activeIndex);
        // Nur wirklich gravierte Flaschen bekommen das Häkchen — leer ist zwar
        // gültig, aber eben keine Gravur.
        chip.classList.toggle('is-done', this.isEngraved(this.engravings[index]));
      });
    }

    /**
     * DEV-ANZEIGE der zukuenftigen Mengenrabatt-Regel (snippets/sf-dev-volume-discount):
     * ab Mindestmenge ein fester Betrag pro Flasche, Gravurgebuehr ausgeschlossen.
     * Nur Darstellung — was Shopify im Warenkorb und Checkout rechnet, bleibt unberuehrt.
     */
    devVolumeDiscount(bottleCount) {
      let rule = {};
      try { rule = JSON.parse(this.dataset.devVolumeDiscount || '{}'); } catch (error) { rule = {}; }
      const minQuantity = Number(rule.minQuantity);
      const perBottleCents = Number(rule.perBottleCents);
      if (!(minQuantity > 0) || !(perBottleCents > 0) || bottleCount < minQuantity) return 0;
      return bottleCount * perBottleCents;
    }

    /**
     * Aktionsrabatt aus dem Angebotsfeld derselben Seite (z. B. Black Month, sf-offer-box):
     * unter der Mindestmenge ein fester Betrag oder Prozent pro Flasche. Nur Anzeige — den
     * Abzug macht der automatische Rabatt im Admin. Ohne Angebotsfeld: 0.
     */
    offerDiscount(bottleCount, bottleTotal) {
      if (!this.formId) return { amount: 0, label: '' };
      const box = document.querySelector(`sf-offer-box[data-form-id="${CSS.escape(this.formId)}"]`);
      if (!box) return { amount: 0, label: '' };
      const minQuantity = Number(box.dataset.minQuantity || 3);
      if (bottleCount >= minQuantity) return { amount: 0, label: '' };
      const saving = Number(box.dataset.singleSaving || 0);
      const percent = Number(box.dataset.singleDiscount || 0);
      const amount = saving > 0 ? bottleCount * saving : Math.round((bottleTotal * percent) / 100);
      const label = box.querySelector('.sf-offer-box__title')?.textContent.trim() || '';
      return { amount: Math.max(0, amount), label };
    }

    renderSummary() {
      if (!this.summary) return;

      const bottleTotal = this.bottles.reduce((sum, bottle) => sum + Number(bottle.price || 0), 0);
      const engraved = this.engravedCount();
      const feeTotal = this.feeCents * engraved;
      const offer = this.offerDiscount(this.bottles.length, bottleTotal);
      const discount = this.devVolumeDiscount(this.bottles.length) || offer.amount;
      const total = bottleTotal - discount + feeTotal;
      const label = this.bottles.length === 1 ? 'SideFill' : `SideFill × ${this.bottles.length}`;

      const feeRow = engraved > 0
        ? `<div class="sf-engraving__summary-row"><span>${((window.SideFillStrings || {}).engravingLabel || 'Gravur')} × ${engraved}</span><span>${this.money(feeTotal)}</span></div>`
        : `<div class="sf-engraving__summary-row"><span>${((window.SideFillStrings || {}).engravingLabel || 'Gravur')}</span><span>${this.escape(this.dataset.labelNoEngraving || ((window.SideFillStrings || {}).engravingNoneSelected || 'keine gewählt'))}</span></div>`;

      if (this.footerCounts) {
        const bottles = `${this.bottles.length} ${this.bottles.length === 1 ? 'SideFill' : 'SideFills'}`;
        this.footerCounts.textContent = engraved > 0
          ? `${bottles} · ${engraved} ${engraved === 1 ? ((window.SideFillStrings || {}).engravingLabel || 'Gravur') : ((window.SideFillStrings || {}).engravingPlural || 'Gravuren')}`
          : bottles;
      }
      if (this.footerTotal) this.footerTotal.textContent = this.money(total);
      this.renderMail();

      const discountRow = discount > 0
        ? `<div class="sf-engraving__summary-row"><span>${this.escape(offer.amount > 0 && offer.label ? offer.label : ((window.SideFillStrings || {}).cartQuantityDiscount || 'Mengenrabatt'))}</span><span>−${this.money(discount)}</span></div>`
        : '';

      this.summary.innerHTML = `
        <div class="sf-engraving__summary-row"><span>${label}</span><span>${this.money(bottleTotal)}</span></div>
        ${discountRow}
        ${feeRow}
        <div class="sf-engraving__summary-row is-total"><span>Gesamt</span><span>${this.money(total)}</span></div>
      `;
    }

    syncValidity() {
      if (!this.addButton) return;
      // Leere Felder blockieren nichts — nur wirklich ungültige Zeichen tun das.
      this.addButton.disabled = !this.engravings.every((value) => this.isValid(value));
    }

    /** Baut eine Zeile je Flasche. Siehe Property-Schema oben in dieser Datei. */
    buildItems(groupId) {
      const count = this.bottles.length;
      const engraved = this.engravedCount();

      const items = this.bottles.map((bottle, index) => {
        const text = String(this.engravings[index] || '').trim();
        const properties = {
          Flasche: `${index + 1} / ${count}`,
          Farbe: bottle.color,
          _bundle_group_id: groupId,
          _bottle_index: String(index + 1),
          _bottle_count: String(count),
          _engraving_config_id: bottle.configId || '',
          _personalized: '1',
          _flow: 'a',
          _flow_version: this.flowVersion
        };

        // Nur gravierte Flaschen tragen einen Text — sonst wäre im Warenkorb eine
        // leere Gravur zu sehen und die Gebührenzählung würde sie mitzählen.
        if (text) {
          properties.Gravur = text;
          properties._engraving_text = text;
        }

        return { id: Number(bottle.id), quantity: 1, properties };
      });

      if (this.feeVariantId && engraved > 0) {
        items.push({
          id: Number(this.feeVariantId),
          quantity: engraved,
          properties: {
            _engraving_fee: '1',
            _bundle_group_id: groupId,
            _bottle_count: String(count)
          }
        });
      }

      return items;
    }

    async addToCart() {
      if (!this.bottles.length) return;

      if (!this.engravings.every((value) => this.isValid(value))) {
        this.showError(this.dataset.labelInvalid);
        const first = this.engravings.findIndex((value) => !this.isValid(value));
        this.querySelector(`[data-sf-engrave-input="${first + 1}"]`)?.focus();
        return;
      }

      // Ohne Gebührenvariante darf nur bestellt werden, wenn auch nichts graviert wird.
      if (!this.feeVariantId && this.engravedCount() > 0) {
        this.showError(((window.SideFillStrings || {}).engravingFeeMissing || 'Der Gravur-Aufpreis ist im Shop nicht konfiguriert. Bitte kurz melden.'));
        return;
      }

      const groupId = globalThis.crypto?.randomUUID?.() || `flow-a-${Date.now()}`;
      const items = this.buildItems(groupId);
      const root = (window.Shopify?.routes?.root || '/').toString();
      const base = root.endsWith('/') ? root : `${root}/`;

      this.addButton.disabled = true;
      this.hideError();
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
      );

      try {
        const response = await fetch(`${base}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });

        const json = await response.json();

        if (!response.ok) {
          this.showError(json?.description);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        try {
          sessionStorage.removeItem(window.SFEngraving.handoverKey);
        } catch (error) {
          /* Speicher deaktiviert — nichts aufzuräumen */
        }

        // Gekauft ist gekauft: der Dialog startet beim nächsten Mal leer.
        this.forgetTexts();
        this.dispatchEvent(new CustomEvent('sf:panel-added', { bubbles: true }));

        if (
          window.themeVariables?.settings?.cartType === 'page' ||
          window.themeVariables?.settings?.pageType === 'cart'
        ) {
          window.location.href = this.dataset.cartUrl;
          return;
        }

        const cart = await (await fetch(`${base}cart.js`)).json();
        cart.sections = json.sections;

        // Die theme-eigenen Warenkorb-Ereignisse — sie öffnen den bestehenden Drawer.
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: 'open_drawer', cart }
          })
        );
      } catch (error) {
        this.showError();
      } finally {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        this.addButton.disabled = false;
        this.syncValidity();
      }
    }

    /**
     * Formatiert wie der übrige Shop. Intl mit der Shop-Locale "de" ergäbe
     * "149,70 CHF" — der Shop schreibt aber "CHF 149.70". Deshalb das
     * Shopify-eigene money_format statt einer eigenen Konvention.
     */
    money(cents) {
      const format =
        this.dataset.moneyFormat ||
        window.themeVariables?.settings?.moneyFormat ||
        'CHF {{amount}}';
      const value = Number(cents || 0) / 100;

      const group = (text, thousands) => {
        const [whole, fraction] = text.split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fraction ? grouped + (thousands === '.' ? ',' : '.') + fraction : grouped;
      };

      return format
        .replace(/\{\{\s*amount\s*\}\}/g, group(value.toFixed(2), ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(value.toFixed(2), '.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(Math.round(value).toString(), ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(Math.round(value).toString(), '.'));
    }

    escape(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      })[character]);
    }

    showError(message) {
      if (!this.errorNode) return;
      this.errorNode.textContent =
        message || ((window.SideFillStrings || {}).cartUpdateError || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte noch einmal versuchen.');
      this.errorNode.hidden = false;
    }

    hideError() {
      if (!this.errorNode) return;
      this.errorNode.hidden = true;
      this.errorNode.textContent = '';
    }
  }

  if (!customElements.get('sf-engraving')) {
    customElements.define('sf-engraving', SfEngraving);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-offer-box"] && !Shopify.designMode) return;
  try {
    class SfOfferBox extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.formId = this.dataset.formId;
      const form = document.getElementById(this.formId);
      this.input =
        form?.querySelector('[name="quantity"]') ||
        document.querySelector(`[name="quantity"][form="${CSS.escape(this.formId)}"]`);
      if (!this.input) {
        requestAnimationFrame(() => this.connectedCallback());
        return;
      }
      this.dataset.initialized = 'true';

      try {
        this.colours = JSON.parse(this.querySelector('[data-offer-colours]')?.textContent || '[]');
      } catch (error) {
        this.colours = [];
      }
      // Wie in der Farbwahl: Startfarbe vorne, Ausverkauftes hinten.
      const rank = (colour) => (colour.start && colour.available ? -1 : colour.available ? 0 : 1);
      this.colours = this.colours.map((colour, index) => ({ ...colour, index }))
        .sort((a, b) => rank(a) - rank(b) || a.index - b.index);

      this.onClick = (event) => {
        const swatch = event.target.closest('[data-offer-swatch]');
        if (swatch) {
          this.pickColour(Number(swatch.dataset.slot), swatch.dataset.variant);
          return;
        }
        if (event.target.closest('.sf-offer-box__bottles')) return;
        const card = event.target.closest('[data-offer-tier]');
        if (card) this.selectTier(card);
      };
      this.onKeydown = (event) => {
        const main = event.target.closest('.sf-offer-box__main');
        if (!main || event.target !== main) return;
        const card = main.closest('[data-offer-tier]');
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectTier(card);
          return;
        }
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(event.key)) return;
        event.preventDefault();
        const cards = [...this.querySelectorAll('[data-offer-tier]')];
        const step = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
        const next = cards[(cards.indexOf(card) + step + cards.length) % cards.length];
        this.selectTier(next);
        next.querySelector('.sf-offer-box__main')?.focus();
      };
      // Die Farbwahl meldet jede Änderung der Flaschenfarben; Menge kommt über das Feld.
      this.onMix = (event) => {
        if (event.detail?.formId !== this.formId) return;
        this.renderBottles();
      };
      this.onQuantityChange = () => this.render();
      this.onEngravingMode = (event) => {
        if (event.detail?.formId === this.formId) this.render();
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('sf:color-mix', this.onMix);
      document.addEventListener('sf:engraving-mode', this.onEngravingMode);
      this.input.addEventListener('input', this.onQuantityChange);
      this.input.addEventListener('change', this.onQuantityChange);
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('sf:color-mix', this.onMix);
      document.removeEventListener('sf:engraving-mode', this.onEngravingMode);
      this.input?.removeEventListener('input', this.onQuantityChange);
      this.input?.removeEventListener('change', this.onQuantityChange);
      this.dataset.initialized = 'false';
    }

    selectTier(card) {
      if (String(this.quantity()) === card.dataset.offerTier) return;
      this.input.value = card.dataset.offerTier;
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.render();
    }

    quantity() {
      return Math.max(1, Math.round(Number(this.input?.value || 1)) || 1);
    }

    /** Klickt den passenden Punkt der Farbwahl; sie wählt (oder zeigt Ausverkauftes nur an). */
    pickColour(slot, variantId) {
      const mix = document.querySelector(`sf-color-mix[data-form-id="${CSS.escape(this.formId)}"]`);
      const target = mix?.querySelector(
        `[data-sf-mix-slot="${slot}"] .sf-color-mix__swatch[data-sf-mix-variant="${CSS.escape(String(variantId))}"]`
      );
      if (target) target.click();
    }

    money(cents) {
      const format = this.dataset.moneyFormat || 'CHF {{amount}}';
      const value = Number(cents || 0) / 100;
      const group = (text, thousands) => {
        const [whole, fraction] = text.split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fraction ? grouped + (thousands === '.' ? ',' : '.') + fraction : grouped;
      };
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, group(value.toFixed(2), ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(value.toFixed(2), '.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(Math.round(value).toString(), ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(Math.round(value).toString(), '.'));
    }

    render() {
      const quantity = this.quantity();
      const unit = Number(this.dataset.unitPrice || 0);
      const perBottle = Number(this.dataset.perBottle || 0);
      const minQuantity = Number(this.dataset.minQuantity || 3);
      const singleDiscount = Number(this.dataset.singleDiscount || 0);
      const singleSaving = Number(this.dataset.singleSaving || 0);

      // Ist die Menge keine der drei Stufen, ist keine Karte gewählt.
      const cards = [...this.querySelectorAll('[data-offer-tier]')];
      const hasMatch = cards.some((card) => Number(card.dataset.offerTier) === quantity);
      cards.forEach((card) => {
        const selected = Number(card.dataset.offerTier) === quantity;
        card.classList.toggle('is-selected', selected);
        const main = card.querySelector('.sf-offer-box__main');
        if (main) {
          main.setAttribute('aria-checked', String(selected));
          main.tabIndex = selected || (!hasMatch && card === cards[0]) ? 0 : -1;
        }
      });

      // Ab 3 Flaschen der Mengenrabatt, darunter der Aktionsrabatt (falls eingestellt).
      let total = quantity >= minQuantity
        ? quantity * unit - quantity * perBottle
        : quantity * unit - (singleSaving > 0 ? quantity * singleSaving : Math.round((quantity * unit * singleDiscount) / 100));
      // Gravur angekreuzt: Aufpreis je Flasche dazu (Betrag aus der Gravurwahl).
      if (window.SFEngraving?.readMode?.(this.formId) === 'engraved') {
        const choice = document.querySelector(`sf-engraving-choice[data-form-id="${CSS.escape(this.formId)}"]`);
        total += quantity * Number(choice?.dataset.feeCents || 0);
      }
      const totalNode = this.querySelector('[data-offer-total]');
      if (totalNode) totalNode.textContent = this.money(total);

      this.renderBottles();
    }

    /** Eine Zeile je Flasche in der gewählten Karte; gewählte Farbe aus der Farbwahl. */
    renderBottles() {
      // Die Zeilen werden neu gebaut; wer per Tastatur auf einem Punkt stand, bleibt dort.
      const active = document.activeElement?.closest?.('[data-offer-swatch]');
      const keep = active && this.contains(active) ? { slot: active.dataset.slot, variant: active.dataset.variant } : null;
      this.querySelectorAll('.sf-offer-box__bottles').forEach((node) => node.remove());
      const card = this.querySelector('.sf-offer-box__card.is-selected');
      if (!card || !this.colours.length) return;

      const quantity = this.quantity();
      const mix = window.SFEngraving?.readColors?.(this.formId) || {};
      const lead = String(document.forms[this.formId]?.elements?.id?.value || '');
      const ids = Array.from({ length: quantity }, (_, index) => String(mix.variantIds?.[index] || mix.variantIds?.[0] || lead));

      const grid = document.createElement('div');
      grid.className = 'sf-offer-box__bottles';
      const head = (text) => {
        const node = document.createElement('span');
        node.className = 'sf-offer-box__bottles-head';
        node.textContent = text;
        return node;
      };
      // Kopf nur über den Punkten; rechts steht je Zeile der gewählte Farbname (die Grösse steht schon über dem Feld).
      grid.append(document.createElement('span'), head(this.dataset.colourLabel || ''), document.createElement('span'));

      ids.forEach((selectedId, index) => {
        const slot = index + 1;
        const number = document.createElement('span');
        number.className = 'sf-offer-box__bottle-number';
        number.textContent = `${slot}.`;

        const swatches = document.createElement('span');
        swatches.className = 'sf-offer-box__swatches';
        swatches.setAttribute('role', 'group');
        swatches.setAttribute('aria-label', `${slot}. ${this.dataset.colourLabel || ''}`);
        this.colours.forEach((colour) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sf-offer-box__swatch';
          button.dataset.offerSwatch = '';
          button.dataset.slot = String(slot);
          button.dataset.variant = String(colour.variant);
          button.dataset.name = colour.name;
          button.dataset.available = String(colour.available);
          button.setAttribute('aria-pressed', String(colour.available && String(colour.variant) === selectedId));
          button.setAttribute('aria-label', colour.name);
          button.title = colour.name;
          const dot = document.createElement('span');
          dot.className = 'sf-offer-box__swatch-colour';
          dot.style.setProperty('--sf-swatch-colour', colour.colour || '#ccc');
          button.append(dot);
          swatches.append(button);
        });

        const name = document.createElement('span');
        name.className = 'sf-offer-box__colour-name';
        name.textContent = this.colours.find((colour) => String(colour.variant) === selectedId)?.name || '';

        grid.append(number, swatches, name);
      });

      card.append(grid);
      if (keep) {
        grid.querySelector(`[data-offer-swatch][data-slot="${keep.slot}"][data-variant="${CSS.escape(keep.variant)}"]`)?.focus();
      }
    }
  }

  if (!customElements.get('sf-offer-box')) {
    customElements.define('sf-offer-box', SfOfferBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-pdp-color-image"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.sfPdpColorSync) return;
    window.sfPdpColorSync = true;

    // Wie der Liquid-Filter `handleize` für die hier vorkommenden Farbnamen.
    const handle = (value) =>
      String(value)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

    document.addEventListener('variant:change', (event) => {
      const options = event.detail?.variant?.options;
      if (!Array.isArray(options)) return;
      const keys = options.map(handle);

      document.querySelectorAll('[data-sf-color-set]').forEach((set) => {
        const items = [...set.querySelectorAll('[data-sf-color]')];
        const match = items.find((item) => keys.includes(item.dataset.sfColor));
        if (!match) return;
        items.forEach((item) => {
          item.hidden = item !== match;
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-pdp-gallery-files"] && !Shopify.designMode) return;
  try {
    // Das Bild zum Lieferumfang zeigt die Flasche in der gewählten Farbe. Beim Farbwechsel
  // zeichnet das Theme die Galerie nicht neu, es blendet nur Bilder ein und aus — darum
  // wird hier die Datei getauscht. Die Dateinamen enden auf den Farbnamen in
  // Handle-Schreibweise («Cream Dune» → cream-dune).
  document.addEventListener('variant:change', (event) => {
    const colour = event.detail?.variant?.option1;
    if (!colour) return;
    const handle = String(colour)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    // Dateiname: sidefill-version-f-lieferumfang-<Fassung>-<farbe>.webp; die Fassung bleibt, die Farbe wechselt.
    const name = /(sidefill-version-f-lieferumfang-(?:\d+-)?)[a-z-]+\.webp/g;
    document.querySelectorAll('.product-gallery img[src*="sidefill-version-f-lieferumfang-"]').forEach((image) => {
      ['src', 'srcset'].forEach((attribute) => {
        const value = image.getAttribute(attribute);
        if (value) image.setAttribute(attribute, value.replace(name, `$1${handle}.webp`));
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-shop-mega-menu"] && !Shopify.designMode) return;
  try {
    /*
    Tastatur fuer das Shop-Panel:
    - Pfeil nach unten auf "Shop" oeffnet es ueber die Oeffnen-Funktion des Themes
      und setzt den Fokus auf die erste Kachel. Enter folgt wie bisher dem Link.
    - Escape schliesst es und gibt den Fokus an "Shop" zurueck. Der Escape-
      Handler des Themes greift hier nie: Er prueft das <details> statt des
      umgebenden dropdown-menu-disclosure. Das Theme selbst bleibt unveraendert.
  */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowDown' && event.key !== 'Escape') return;
    const details = event.target.closest?.('details');
    const panel = details?.querySelector(':scope > .sf-shop-menu');
    if (!panel) return;
    const summary = details.querySelector(':scope > summary');
    const disclosure = details.closest('dropdown-menu-disclosure');

    if (event.key === 'Escape') {
      if (!details.open) return;
      event.preventDefault();
      if (typeof disclosure?.toggle === 'function') disclosure.toggle(false);
      else details.open = false;
      summary?.focus();
      return;
    }

    if (event.target !== summary) return;
    event.preventDefault();
    if (!details.open) {
      if (typeof disclosure?.open === 'function') disclosure.open();
      else details.open = true;
    }
    requestAnimationFrame(() => panel.querySelector('.sf-shop-menu__tile')?.focus());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-shop-page"] && !Shopify.designMode) return;
  try {
    /* Farbwahl in einer Shop-Karte: wechselt Bild, Farbname, Preis, Links und den Zustand des Kaufen-Knopfs. */
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.sf-shop-card__swatch input');
    if (!input) return;

    const card = input.closest('[data-sf-shop-card]');
    if (!card) return;

    const colour = card.querySelector('[data-sf-shop-colour]');
    const price = card.querySelector('[data-sf-shop-price]');
    const button = card.querySelector('[data-sf-shop-button]');
    const image = card.querySelector('.sf-shop-card__media img');
    const available = input.dataset.available === 'true';

    if (colour) colour.textContent = available ? input.dataset.name : `${input.dataset.name} – ${card.dataset.labelSoldOut}`;
    if (price && input.dataset.price) price.textContent = input.dataset.price;

    if (button) {
      button.disabled = !available;
      const label = button.querySelector('[data-sf-shop-button-label]');
      if (label) label.textContent = available ? card.dataset.labelAdd : card.dataset.labelSoldOut;
    }

    if (input.dataset.url) {
      card.querySelectorAll('[data-sf-shop-link]').forEach((link) => { link.href = input.dataset.url; });
    }

    if (image && input.dataset.image) {
      const next = new Image();
      const show = () => {
        if (!input.checked) return;
        image.removeAttribute('srcset');
        image.src = input.dataset.image;
        card.classList.remove('is-swapping');
      };
      card.classList.add('is-swapping');
      next.onload = show;
      next.onerror = show;
      next.src = input.dataset.image;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sidefill-card-buy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target.closest('.sf-card-buy__variant-input');
    if (!input) return;
    const card = input.closest('product-card');
    const picker = input.closest('.sf-card-buy');
    const image = card?.querySelector('.product-card__image--primary');
    const price = card?.querySelector('[data-sidefill-card-price]');
    if (price && input.dataset.price) price.textContent = input.dataset.price;
    if (image && input.dataset.image) {
      image.src = input.dataset.image;
      image.removeAttribute('srcset');
    }
    if (card && picker?.dataset.productUrl) {
      const variantUrl = new URL(picker.dataset.productUrl, window.location.origin);
      variantUrl.searchParams.set('variant', input.value);
      card.querySelectorAll('.product-card__media, .product-title').forEach((link) => {
        link.href = `${variantUrl.pathname}${variantUrl.search}`;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sidefill-volume-tiers"] && !Shopify.designMode) return;
  try {
    class SidefillVolumeTiers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.form = document.getElementById(this.dataset.formId);
      this.input = this.form?.querySelector('[name="quantity"]') || document.querySelector(`[name="quantity"][form="${CSS.escape(this.dataset.formId)}"]`);
      if (!this.input) {
        requestAnimationFrame(() => this.connectedCallback());
        return;
      }
      this.dataset.initialized = 'true';

      this.onClick = (event) => {
        const button = event.target.closest('[data-volume-tier]');
        if (!button) return;
        const quantity = Number(button.dataset.volumeTier || 1);
        this.input.value = String(quantity);
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.render();
      };
      this.onQuantityChange = () => this.render();
      // Der Klick kommt hier nach dem Handler des Themes an, das Mengenfeld ist also schon
      // aktualisiert. Direkt zeichnen statt auf den nächsten Frame zu warten — in einem
      // Hintergrund-Tab kommt der nie. Der Timer fängt verzögerte Änderungen ab.
      this.onQuantityClick = () => {
        this.render();
        setTimeout(() => this.render(), 0);
      };
      this.addEventListener('click', this.onClick);
      this.input.addEventListener('input', this.onQuantityChange);
      this.input.addEventListener('change', this.onQuantityChange);
      this.input.closest('quantity-selector')?.addEventListener('click', this.onQuantityClick);
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.input?.removeEventListener('input', this.onQuantityChange);
      this.input?.removeEventListener('change', this.onQuantityChange);
      this.input?.closest('quantity-selector')?.removeEventListener('click', this.onQuantityClick);
    }

    render() {
      const quantity = Math.max(1, Number(this.input?.value || 1));
      this.querySelectorAll('[data-volume-tier]').forEach((button) => {
        const selected = Number(button.dataset.volumeTier) === quantity;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      // Das Mengenfeld steht immer unter den Karten. Die Zeile daneben spricht nur, wenn die
      // Karten es nicht tun: bei 2 Stück die Regel als Anreiz, bei 4 und ab 6 die Ersparnis
      // als Bestätigung. Bei 1, 3 und 5 bleibt sie leer. Cart-Rabatte kommen aus Shopify.
      const status = this.querySelector('[data-volume-tier-status]');
      if (status) {
        let text = '';
        if (quantity === 2) {
          text = (window.SideFillStrings || {}).volumeTierHint || 'Ab 3 Flaschen sparst du CHF 10 pro Flasche';
        } else if (quantity > 3 && quantity !== 5) {
          const amount = (this.dataset.moneyPattern || 'CHF [n]').replace('[n]', String(quantity * Number(this.dataset.perBottle || 10)));
          text = (this.dataset.savingText || '[amount] sparen').replace('[amount]', amount);
        }
        status.textContent = text;
        status.dataset.state = quantity < 3 ? 'hint' : 'saving';
      }
    }

  }

  if (!customElements.get('sidefill-volume-tiers')) {
    customElements.define('sidefill-volume-tiers', SidefillVolumeTiers);
  }
  } catch(e) { console.error(e); }
})();

})();
